import React, { useState, useEffect, useRef, useMemo } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import * as moment from "moment";
import { MoreOutlined, EyeOutlined } from "@ant-design/icons";
import PhotoSelect from "../ui/PhotoSelect";
import { ConnectedImageButtonContainer } from "../ui/PhotoSelect";
import ConfirmDelete from "../ui/ConfirmDelete";
import Html5QrcodePlugin from "../ui/Html5QrcodePlugin.jsx";
import ConfirmDeleteArsenal from "../ui/ConfirmDeleteArsenal";
import NoSerialNumberAlert from "../ui/NoSerialNumberAlert";
import { Select } from "antd";
import Modal from "react-bootstrap/Modal";
import BallShadow from "../../images/arsenal_shadow.png";
import BowlingDatabaseLogo from "../../images/bowlingdatabase.png";
import { getCustomer } from "../bowlers/bowlers.redux";
import { openPhoto } from "../login/userSession.redux";
import { getPhotoForUserId } from "../../utils/utils";
import { toDecimal, radians, degrees, toFractionRound } from "../../utils";
import { JobBoardBallList } from "./JobBoardBallList";
import DateTimePicker from "react-datetime-picker";
import calendarIcon from "../../images/dashboard/Calendar_icon.png";
import { Printer, Search, X, List, Trash, CartPlus } from "react-bootstrap-icons";
import InsertColorPicker, { hasAnyInsertVariants } from "./InsertColorPicker";
import {
  resolveInsertUpc,
  resolveThumbSimpleUpc,
  resolveThumbSwitchInnerUpc,
  resolveThumbSwitchOuterUpc,
} from "../db/datafixtures/insert_variants_helpers";
import { BowlerHeader, HeaderActionButton } from "../ui/BowlerHeader";
import ball_icon_blue from "../../images/speechsheet/ball_icon_blue.svg";
import Modal3dError from "../modal/Modal3dError";
import {
  FileText,
  BoxArrowUpRight,
  UpcScan,
  AspectRatio,
} from "react-bootstrap-icons";
import ButtonIcon from "react-bootstrap/Button";
import {
  setLoadBalls,
  ballHandleForm,
  ballAddNew,
  ballRemove,
  ballSelect,
  ballSavePhoto,
  ballRemovePhoto,
  createJob,
  readBarcode,
  readBarcodeSuccess,
  getBallDatabaseInfo,
  getBallDatabaseInfoScan,
  getBallDatabaseSearch,
  setBallDatabaseInfo,
  setOpenBallDatabaseSearch,
  setShowConfirmDeleteArsenal,
} from "../arsenal/arsenal.redux";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import { DebounceInput } from "react-debounce-input";
import { DEBOUNCE_INPUT_PROPS } from "../../const";
import BallSearch from "./BallSearch";
import ModalNoPAP from "../modal/ModalNoPAP";
import styled, { css } from "styled-components";
import ballImageDefault from "../../images/default2025.png";
import "./styles.css";
import Spinner from "../ui/Spinner";
import Loader from "../ui/Loader";
import {
  idx_data_ball_manufacturer,
  idx_data_ball_weight,
  idx_data_angle,
  idx_data_angle_1,
  idx_data_pap_length,
  idx_data_pin_cog_length,
  idx_data_surface,
  idx_data_suggested_layout,
  idx_data_weight_hole_position,
  idx_data_hole_sizes,
  idx_data_weight_hole_depth,
} from "../db/datafixtures/datafixtures";
import Image from "../ui/Image";
import BallGLView from "../3d/BallGLView";
import {
  isValidDualAngleLayout,
  isValidVLSLayout,
  isValid2LSLayout,
  isValidPALLayout,
} from "../3d/utils/layoutUtils";
import ModalHoleDepth from "../modal/ModalHoleDepth";
import {
  woocommerceCheckUserExists,
  woocommerceCheckBallInOpenOrder,
  resetErrorMessage,
} from "../plugins/plugin.redux";
import ModalUpdateError from "../modal/ModalUpdateError";
import { ModalPdfPreview } from "../modal/ModalPdfPreview";
import ConfirmDialog from "../feedback/ConfirmDialog";

const BarcodeReader = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  background-color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  top: 0;
  left: 0;
`;

const labelStyle = {
  textAlign: "left",
  display: "flex",
  alignItems: "flex-end",
  fontSize: "12px",
  fontWeight: "700",
  letterSpacing: "0px",
  color: "#00197B",
  opacity: "1",
};

const customerNameStyle = {
  font: "normal normal bold 16px / 20px Lato",
  letterSpacing: "0px",
  color: "#000000",
  opacity: "1",
  fontWeight: "700",
  order: 1,
};

const Label = styled.div`
  text-align: left;
  font: 14px;
  font-weight: 600;
  letter-spacing: 0px;
  color: #000000;
  margin-bottom: 1em;
`;

const CreateJobContainer = styled.div`
  margin-top: 10em;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

const imgPrinterStyle = {
  width: "30px",
  height: "22px",
  marginRight: "2px",
};

const ButtonAddNew = styled.button`
  width: 125px;
  height: 48px;
  border: none;
`;

const ButtonCreateJob = styled.button`
  width: 125px;
  height: 48px;
  border: none;
`;

const BallFormNoteLazy = React.lazy(() => import("../ball/ballFormNote.jsx"));

const ImageLoader = styled.div`
  width: 50px;
  height: 50px;
`;

const DateDrilledContainer = styled.div`
  position: relative;
  width: 100%;
`;
const DateDrilledTitle = styled.label`
  position: absolute;
  top: 13px;
  left: 4px;
  z-index: 90;
  color: #00197b;
`;
const ShadowImage = styled.div`
  position: absolute;
  bottom: -50px;
  background-image: url(${BallShadow});
  background-repeat: no-repeat;
  background-position: center center;
  width: 100%;
  height: 100px;
  background-size: 100% 100px;
`;

const ImageContainer = styled.div`
  margin-top: 6em;
  padding: 2%;
  height: unset;
  aspect-ratio: 137.07 / 146.69;
  max-height: 743px;
  max-width: 100%;
  min-width: 40%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-bottom: 5vh;
  position: relative;

  @media only screen and (max-width: 990px) {
    flex-direction: column;
    justify-content: center;
    padding: 3%;
    // padding-left: 0;
    margin-top: 18em;
  }
  @media only screen and (max-width: 360px) {
    padding: 10%;
  }
`;

const BallInfo = styled.div`
  @media only screen and (max-width: 991px) {
    margin-bottom: 5vh;
    margin-top: 1em;
  }
`;

const BallActionsBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
  margin-bottom: 16px;
`;

const BallContainerInfo = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;

  @media only screen and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
    justify-content: center;
    align-items: center;
    flex-direction: column-reverse;
  }
`;

const Button = styled.button`
  position: absolute;
  top: 5px;
  right: 5px;
  border-radius: 50%;
  background: #00147b80 0% 0% no-repeat padding-box;
  color: #ffffff;
  width: 30px;
  height: 30px;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #00147b 0% 0% no-repeat padding-box;
  }
`;

const ButtonEye = styled.button`
  border-radius: 50%;
  background: #00147b80 0% 0% no-repeat padding-box;
  color: #ffffff;
  width: 30px;
  height: 30px;
  border: none;
  margin-left: 1em;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #00147b 0% 0% no-repeat padding-box;
  }
`;

const SectionLayoutType = styled.div`
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  border: 1px solid var(--unnamed-color-d4d4d5);
  background: #ffffff 0% 0% no-repeat padding-box;
  opacity: 1;
  width: 130px;

  ${(props) =>
    props.primary &&
    css`
      width: auto;
    `}
  ${(props) =>
    props.big &&
    css`
      width: auto;
    `}
`;

const BallDatabaseSearchInput = styled(Form.Control)`
  &::placeholder {
    font-size: 12px;
    text-decoration: italic;
  }
  color: #00197b;
`;

const DateTimePickerInput = styled(DateTimePicker)`
  width: 100%;
  height: 48px;
  background-color: #ffffff;
  padding-left: 10px;
  border: 1px solid #d4d4d5;
  border-radius: 5px;

  & .react-datetime-picker__wrapper {
    border-radius: 5px;
    border: none;
    color: #00197b;
  }
`;
const DescriptionTextLayoutType = styled.span`
  font: var(--unnamed-font-style-normal) normal
    var(--unnamed-font-weight-normal) 10px / var(--unnamed-line-spacing-36)
    var(--unnamed-font-family-poppins);
  letter-spacing: var(--unnamed-character-spacing-0);
  color: var(--unnamed-color-707070);
  text-align: center;
  font: normal normal normal 10px/36px Poppins;
  letter-spacing: 0px;
  color: #707070;
  opacity: 1;
  display: flex;
  line-height: 1;
  justify-content: center;
  margin-bottom: 1.8vh;
`;
const SpanTextStyle = styled.span`
  color: #00197b;
  background: transparent;
  border: transparent;
  letter-spacing: 0.07px;
  font-weight: 700;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  order: 5;
  text-wrap: nowrap;

  @media only screen and (max-width: 900px) and (orientation: portrait) {
    font-size: 12px;
  }
  @media only screen and (max-width: 450px) and (orientation: portrait) {
    font-size: 10px;
  }
`;

const ButtonLayoutType = styled.button`
  display: inline-block;
  margin: 0.5rem 0;
  width: 52px;
  height: 55px;
  background: ${(props) => (props.active === true ? "#00297A" : "#E0E1E2")};
  color: ${(props) => (props.active === true ? "#FFFFFF" : "#00000099")};
  border: 2px solid white;
  font: normal normal 600 12px/18px Poppins;
  font-weight: 700;
  text-align: center;
  padding: 0;
  vertical-align: bottom;

  @media only screen and (max-width: 900px) and (orientation: portrait) {
    width: 45px;
    height: 48px;
  }
  @media only screen and (max-width: 450px) and (orientation: portrait) {
    width: 40px;
    height: 40px;
  }
  ${(props) =>
    props.primary &&
    css`
      padding: 0.5rem 1.5rem;
      margin: 0.5rem 1rem;
      border-radius: 7px;
      width: 110px;
      font: normal normal 600 32px var(--unnamed-font-family-poppins);
      font-weight: 700;
      color: #ffffff;
      opacity: 1;
      letter-spacing: 0px;

      @media only screen and (max-width: 900px) and (orientation: portrait) {
        text-align: center;
        font: normal normal 600 32px/48px Poppins;
        width: 70px;
        padding: 0;
      }
      @media only screen and (max-width: 450px) and (orientation: portrait) {
        padding: 0;
        margin: 0;
        width: 68px;
      }
    `}
  ${(props) =>
    props.left &&
    css`
      border-radius: 8px 0px 0px 8px;
      margin: 0.5rem 0;
    `}
    ${(props) =>
    props.right &&
    css`
      border-radius: 0px 8px 8px 0px;
      margin: 0.5rem 0.01rem;
      width: 53px;
    `}
    ${(props) =>
    props.reduceSize &&
    css`
      font: var(--unnamed-font-style-normal) normal 600
        var(--unnamed-font-size-12) / 15px var(--unnamed-font-family-poppins);
      font: normal normal 600 11px/15px Poppins;
    `}
    
    &:hover {
    background: #00187e;
    color: #ffffff;
  }
`;

const titleStyle = {
  font: "normal normal bold 28px / 36px Lato",
  letterSpacing: "0px",
  color: "#000000",
  opacity: "1",
  fontWeight: "700",
  display: "flex",
  margin: "0",
  justifyContent: "flex-start",
};

const imageBall = {
  width: "100%",
  height: "unset",
};

const marginRules = {
  width: "100%",
  maxWidth: "1024px",
  margin: "16px 2vw 10vh 2vw",
  overflow: "hidden",
};
const menuStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
  margin: "0",
  width: "100%",
  overflow: "hidden",
};
const imageStyle = {
  width: "60px",
  height: "60px",
  marginRight: "10px",
};
const HoleDepthSection = styled.div`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: #ffffff;
  border: 2px solid #00197b;
  color: #00197b;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  @media only screen and (max-width: 991px) {
    width: 60px;
    height: 60px;
  }
`;
const GreyBar = styled.div`
  position: fixed;
  top: 55px;
  z-index: 100;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background-color: #e2e2e2;
  width: 60vw;
  height: 80px;
  margin-right: 2vw;
  margin-top: 5px;
  padding-left: 1vw;

  @media only screen and (max-width: 1280px) {
    top: 59px;
    flex-direction: column;
    width: 100vw;
    margin-right: 0px;
  }
`;

const textStyles = {
  color: "#00197B",
  background: "transparent",
  border: "transparent",
  letterSpacing: "0.07px",
  fontWeight: "700",
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  order: 5,
  marginRight: "15px",
};

const formDoubleColumnStyle = {
  display: "flex",
};
const spaceStyle = {
  marginBottom: "3vh",
};
const dropdownStyle = {
  width: "100%",
  height: "48px",
  color: "#00197B",
  marginBottom: "2vh",
};

const containerBallInfo = {
  display: "flex",
  justifyContent: "flex-start",
};

const searchBaseFilters = {
  rg: [2.46, 2.8],
  diff: [0.02, 0.058],
  int: [0, 2.57],
};

const setBallLayout = (currentLayout) => (ball) => {
  const layout = ball.layout ? ball.layout.split(" X ") : [];

  switch (currentLayout) {
    case "dual_angle":
      return {
        ...ball,
        drilling_angle: layout.length > 0 ? layout[0] : null,
        pin_to_pap: layout.length > 1 ? layout[1] : null,
        val_angle: layout.length > 2 ? layout[2] : null,
      };
    case "vls":
      return {
        ...ball,
        pin_to_pap: layout.length > 0 ? layout[0] : null,
        psa_to_pap: layout.length > 1 ? layout[1] : null,
        pin_buffer: layout.length > 2 ? layout[2] : null,
      };
    case "2ls":
      return {
        ...ball,
        pin_to_pap: layout.length > 0 ? layout[0] : null,
        psa_to_pap: layout.length > 1 ? layout[1] : null,
        pin_to_center: layout.length > 2 ? layout[2] : null,
      };
    case "pal":
      return {
        ...ball,
        pin_to_pap: layout.length > 0 ? layout[0] : null,
        psa_to_pap: layout.length > 1 ? layout[1] : null,
        pin_above_line: layout.length > 2 ? layout[2] : null,
      };

    case "none":
    default:
      return ball;
  }
};

export const BallRedux = (props) => {
  const [show3D, setshow3D] = useState(false);
  const [showPhotoModal, setPhotoShowModal] = useState(false);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [readingSerialNumber, setReadingSerialNumber] = useState(false);
  const [showNoSerialNumberAlert, setShowNoSerialNumberAlert] = useState(false);
  const [showWeightHole, setShowWeightHole] = useState(false);
  const [localCurrentBall, setLocalCurrentBall] = useState(
    setBallLayout(props.currentBall.layout_type || props.currentLayout)(
      props.currentBall,
    ),
  );
  const [ballSearch, setBallSearch] = useState("");
  const [showSearchBallModal, setShowSearchBallModal] = useState(false);
  const [showNoPAPModal, setShowNoPAPModal] = useState(false);
  const [showHoleDepthModal, setShowHoleDepthModal] = useState(false);
  const [showPdfPreview, setShowPdfPreview] = useState(false);
  const [showAddToOrderConfirm, setShowAddToOrderConfirm] = useState(false);
  const [showInsertPicker, setShowInsertPicker] = useState(false);
  const [showAddOrReplaceConfirm, setShowAddOrReplaceConfirm] = useState(false);
  const [pendingPickerResult, setPendingPickerResult] = useState(null);
  const [pendingPosNav, setPendingPosNav] = useState(false);
  const lastSeenOrderEventSeqRef = useRef(0);
  const lastSeenBallCheckSeqRef = useRef(0);
  const lastSeenMissingInsertsSeqRef = useRef(0);
  const lastSeenOrderErrorSeqRef = useRef(
    props.last_pos_order_error_seq || 0,
  );
  const posTabRef = useRef(null);
  const [holeNumberValue, setHoleNumberValue] = useState(0);
  const [firstHoleDepth, setFirstHoleDepth] = useState(0);
  const [secondHoleDepth, setSecondHoleDepth] = useState(0);
  const [thumbHoleDepth, setThumbHoleDepth] = useState(0);
  const [forceLocalCurrentBallUpdate, setForceLocalCurrentBallUpdate] =
    useState(false);
  const [pageSize, setPageSize] = useState(60);
  const [actPage, setActPage] = useState(1);
  const [rangeInitial, setRangeInitial] = useState(0);
  const [rangeFinal, setRangeFinal] = useState(59);
  const [order, setOrder] = useState([
    ["release_date", "DESC"],
    ["manufacturer", "ASC"],
  ]);

  const [rgMinValue, setRgMinValue] = useState(searchBaseFilters.rg[0]);
  const [rgMaxValue, setRgMaxValue] = useState(searchBaseFilters.rg[1]);
  const [diffMinValue, setDiffMinValue] = useState(searchBaseFilters.diff[0]);
  const [diffMaxValue, setDiffMaxValue] = useState(searchBaseFilters.diff[1]);
  const [intMinValue, setIntMinValue] = useState(searchBaseFilters.int[0]);
  const [intMaxValue, setIntMaxValue] = useState(searchBaseFilters.int[1]);
  const [hasError, setHasError] = useState(false);
  const [size, setSize] = useState();
  const [filtersManufacturer, setFiltersManufacturer] = useState();
  const [coreType, setCoreType] = useState();
  const [coreName, setCoreName] = useState();
  const [coverstock, setCoverstock] = useState();

  const [showAlert, setShowAlert] = useState(false);
  const [showAlertMessage, setShowAlertMessage] = useState("");
  const [showAlertHeader, setShowAlertHeader] = useState("");

  const {
    balls_drilled,
    currentLayout,
    specsheets,
    currentSpecSheet,
    userId,
    getCustomer,
    loadingCustomer,
    ballHandleForm,
    ballAddNew,
    ballSelect,
    ballSavePhoto,
    ballRemovePhoto,
    ballRemove,
    currentBall,
    selectedCustomer,
    savingPhoto,
    is2Hander,
    havePap,
    papH,
    papV,
    papDirection,
    isReadOnly,
    deviceInfo,
    pluginSubscriptions,
    createJob,
    currentJobs,
    plugin_settings,
    jobServices,
    openPhoto,
    readBarcode,
    readBarcodeSuccess,
    readingBarcode,
    require_serial_number,
    getBallDatabaseInfo,
    showSuggestedLayouts,
    dualAngleMeasurment,
    isPhone,
    gettingBallDatabaseInfo,
    getBallDatabaseInfoScan,
    settingBallDatabaseInfo,
    convertSettings,
    ballDatabaseBalls,
    ballDatabaseBallsTotalRecords,
    getBallDatabaseSearch,
    setBallDatabaseInfo,
    ballDatabaseSelectedBalls,
    filters,
    openBallDatabaseSearch,
    setOpenBallDatabaseSearch,
    spanMeasurement,
    display_measurement,
    access_token,
    api_key,
    api_secret,
    api_url,
    errorMessage,
    resetErrorMessage,
    woocommerceCheckUserExists,
    showConfirmDeleteArsenal,
    setShowConfirmDeleteArsenal,
    last_woocommerce_order_id,
    last_woocommerce_order_event_seq,
    ball_in_order_check_seq,
    ball_in_order_check_result,
    woocommerceCheckBallInOpenOrder,
    last_missing_inserts,
    last_missing_inserts_seq,
    last_pos_open_url,
    last_pos_order_error,
    last_pos_order_error_seq,
    posSendFromSpectre,
  } = props;

  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const bowlerID = params.bowlerID;
  const ballID = params.ballID;
  const isSSR = typeof window === "undefined";

  console.log("SPECTS: ", specsheets);
  useEffect(() => {
    if (openBallDatabaseSearch) {
      handleBallSearch({
        filter: ballSearch,
        rangeInitial,
        rangeFinal,
        filters: {},
        order,
      });
    }
  }, [openBallDatabaseSearch]);

  useEffect(() => {
    if (settingBallDatabaseInfo && !gettingBallDatabaseInfo) {
      setForceLocalCurrentBallUpdate(true);
      setBallSearch("");
    }
  }, [settingBallDatabaseInfo]);

  useEffect(() => {
    if (!selectedCustomer && !currentBall?.id) {
      getCustomer({ customer_id: bowlerID, setCurrentball: ballID });
    } else {
      if (
        forceLocalCurrentBallUpdate ||
        localCurrentBall?.note !== currentBall?.note
      ) {
        setLocalCurrentBall(
          setBallLayout(currentBall.layout_type || currentLayout)(currentBall),
        );
      } else {
        if (
          (!localCurrentBall?.id && currentBall?.id) ||
          localCurrentBall?.id !== currentBall?.id
        ) {
          setLocalCurrentBall(
            setBallLayout(currentBall.layout_type || currentLayout)(
              currentBall,
            ),
          );
        }
      }
    }
  }, [selectedCustomer, currentBall]);

  useEffect(() => {
    if (errorMessage === "Product not found") {
      setShowAlert(true);
      setShowAlertMessage(errorMessage);
      setShowAlertHeader("woocommerce.error");
    }
  }, [errorMessage]);

  useEffect(() => {
    if (
      last_missing_inserts_seq > lastSeenMissingInsertsSeqRef.current
    ) {
      lastSeenMissingInsertsSeqRef.current = last_missing_inserts_seq;
      if (last_missing_inserts && last_missing_inserts.length > 0) {
        setShowAlert(true);
        setShowAlertHeader("spectrepos.inserts_missing_title");
        setShowAlertMessage({
          userMessage: "spectrepos.inserts_missing_body",
          technicalDetail: last_missing_inserts.join(", "),
        });
      }
    }
  }, [last_missing_inserts_seq, last_missing_inserts]);

  useEffect(() => {
    if (
      pendingPickerResult &&
      ball_in_order_check_seq > lastSeenBallCheckSeqRef.current
    ) {
      lastSeenBallCheckSeqRef.current = ball_in_order_check_seq;
      if (ball_in_order_check_result?.ballInOrder) {
        setShowAddOrReplaceConfirm(true);
      } else {
        setShowAddToOrderConfirm(true);
      }
    }
  }, [
    ball_in_order_check_seq,
    ball_in_order_check_result,
    pendingPickerResult,
  ]);

  useEffect(() => {
    if (
      pendingPosNav &&
      last_woocommerce_order_event_seq > lastSeenOrderEventSeqRef.current
    ) {
      lastSeenOrderEventSeqRef.current = last_woocommerce_order_event_seq;
      setPendingPosNav(false);
      // Hand the POS the numeric order id; the wcpos frontend pulls the
      // order from WC REST, finds its uuid (whichever wcpos has stamped),
      // and switches to /pos/cart/<uuid> internally. Trying to forecast
      // the uuid from v3 is wrong — wcpos owns it.
      // A shop on HBS hands back a signed link that opens the sale in its
      // register; a WordPress shop is reached by its site and the order id.
      const url = last_pos_open_url
        ? last_pos_open_url
        : api_url && last_woocommerce_order_id
          ? `${api_url}/pos/cart?spectre_open=${last_woocommerce_order_id}`
          : api_url
            ? `${api_url}/pos/orders`
            : null;
      if (url) {
        if (posTabRef.current && !posTabRef.current.closed) {
          try {
            posTabRef.current.location.href = url;
            posTabRef.current.focus();
          } catch (_) {
            window.open(url, "_blank", "noopener");
          }
        } else {
          window.open(url, "_blank", "noopener");
        }
      }
      posTabRef.current = null;
    }
  }, [
    pendingPosNav,
    last_woocommerce_order_event_seq,
    last_woocommerce_order_id,
    last_pos_open_url,
    api_url,
  ]);

  // The shop (on HBS) could not add the ball: say why, and do not leave the
  // blank tab that was opened for the register.
  useEffect(() => {
    if ((last_pos_order_error_seq || 0) <= lastSeenOrderErrorSeqRef.current) {
      return;
    }
    lastSeenOrderErrorSeqRef.current = last_pos_order_error_seq;
    if (posTabRef.current && !posTabRef.current.closed) {
      try {
        posTabRef.current.close();
      } catch (_) {
        // nothing to close
      }
    }
    posTabRef.current = null;
    // Only "Add to Order" has someone waiting for an answer; a ball that was
    // just picked from the database and is not in the shop stays quiet, as it
    // always has.
    const asked = pendingPosNav;
    setPendingPosNav(false);
    if (asked && last_pos_order_error?.key) {
      setShowAlert(true);
      setShowAlertHeader("spectrepos.order_failed_title");
      setShowAlertMessage(
        last_pos_order_error.detail
          ? {
              userMessage: last_pos_order_error.key,
              technicalDetail: last_pos_order_error.detail,
            }
          : last_pos_order_error.key,
      );
    }
  }, [last_pos_order_error_seq, last_pos_order_error]);

  const ImageDiv = styled.div`
    position: relative;
    width: ${deviceInfo.isPortrait
      ? deviceInfo.isiPad
        ? "65%"
        : "80%"
      : "100%"};
    height: unset;
    aspect-ratio: 137.07 / 146.69;
    overflow: visible;
    display: flex;
    justify-content: center;
    align-items: flex-end;
  `;

  const { photo } = currentBall;

  const {
    ball_name,
    created_at,
    created_by,
    customer_id,
    id,
    layout_type,
    layout,
    manufacturer,
    spec_sheet,
    spec_sheet_id,
    surface_preparation,
    updated_at,
    updated_by,
    weight,
    weight_hole_depth,
    weight_hole_size,
    weight_hole_position,
    serial_number,
    drilling_angle,
    pin_to_pap,
    val_angle,
    psa_to_pap,
    pin_buffer,
    pin_to_center,
    pin_above_line,
    date_drilled,
    rg,
    diff,
    int_diff,
    core,
    cover,
  } = localCurrentBall;

  // Prefer the live-edited currentSpecSheet (state.specsheet) over the copy
  // embedded in selectedCustomer.specsheets, which only refreshes on a full
  // getCustomer (page reload). Without this, editing the spec sheet (e.g. an
  // insert type) doesn't reflect on the ball screen — the insert picker keeps
  // reading stale grip types — until a hard refresh. Guard on id so it only
  // applies to this ball's spec sheet.
  const specSheetId = spec_sheet?.id || spec_sheet_id;
  const selectedSpecsheet =
    currentSpecSheet && currentSpecSheet.id === specSheetId
      ? currentSpecSheet
      : specsheets.find((spec) => spec.id === specSheetId);

  console.log("Selected Specsheet: ", selectedSpecsheet);
  console.log("HAND: ", selectedSpecsheet);
  console.log("BALL: ", localCurrentBall);

  const lightningLine =
    Math.acos(
      Math.cos(toDecimal(papH, spanMeasurement) / 4.294) *
        Math.cos(toDecimal(papV, spanMeasurement) / 4.294),
    ) * 4.294;
  const [convertTo, setConvertTo] = useState("");
  const [showConversionModal, setShowConversionModal] = useState(false);
  const [show3dErrorModal, setShow3dErrorModal] = useState(false);
  const [show3dErrorType, setShow3dErrorType] = useState(null);
  const getPhoto = getPhotoForUserId(userId);
  const image = getPhoto(photo);
  const userImage = getPhoto(selectedCustomer?.photo);
  const haveWeightHole =
    weight_hole_depth || weight_hole_size || weight_hole_position;

  const handleAddBall = (e) => {
    ballAddNew({});
  };

  const handleDeleteBall = () => {
    // Add call to remove from order if order with the ball exists, and delete the order if it's empty
    if (pluginSubscriptions.indexOf("SPECTRE_POS") >= 0) {
      handleWoocommerceRemoval(localCurrentBall);
    }
    ballRemove({ id });
    navigate(`/arsenal/${bowlerID}`);
  };
  const handleImage = () => {
    if (isReadOnly) return;
    setPhotoShowModal(true);
  };

  const handleValues = (e) => {
    if (isReadOnly) return;
    const value = e.target.value;
    const fieldName = e.nativeEvent.target.name;

    const ball = {
      ...localCurrentBall,
      customer_id: selectedCustomer.id,
      id: ballID,
      [fieldName]: value,
    };

    setLocalCurrentBall(setBallLayout(ball.layout_type || currentLayout)(ball));

    ballHandleForm({
      ball,
    });
  };

  const handle3dClick = () => {
    const selectedLayoutType = localCurrentBall?.layout_type || currentLayout;
    if (!selectedLayoutType || selectedLayoutType === "none") {
      setShow3dErrorType("undefined");
      setShow3dErrorModal(true);
      return;
    }

    // Validar que los datos del layout son suficientes para renderizar
    if (!is3DLayoutValid) {
      setShow3dErrorType("incomplete");
      setShow3dErrorModal(true);
      return;
    }

    setshow3D((prev) => !prev); // Toggle the 3D view
  };

  // Calcular si el layout 3D tiene datos válidos
  const is3DLayoutValid = useMemo(() => {
    const layoutType = localCurrentBall?.layout_type || currentLayout;

    // Convertir valores de PAP del bowler
    const papVertical = toDecimal(papV, spanMeasurement) || 0;
    const papHorizontal = toDecimal(papH, spanMeasurement) || 0;
    const hasPapOffset = papVertical > 0 && papHorizontal > 0;

    if (layoutType === "dual_angle") {
      const pinToPap = toDecimal(localCurrentBall?.pin_to_pap, spanMeasurement);
      const pinAngle = Number(localCurrentBall?.drilling_angle);
      const valAngle = Number(localCurrentBall?.val_angle);

      return (
        isValidDualAngleLayout({
          pinToPapDistance: pinToPap,
          pinAngle,
          valAngle,
        }) && hasPapOffset
      );
    }

    if (layoutType === "vls") {
      const pinToPap = toDecimal(localCurrentBall?.pin_to_pap, spanMeasurement);
      const mbToPap = toDecimal(localCurrentBall?.psa_to_pap, spanMeasurement);
      const pinBuffer = toDecimal(
        localCurrentBall?.pin_buffer,
        spanMeasurement,
      );

      return (
        isValidVLSLayout({
          pinToPapDistance: pinToPap,
          pasToPapDistance: mbToPap,
          pinBufferDistance: pinBuffer,
        }) && hasPapOffset
      );
    }

    if (layoutType === "2ls") {
      const pinToPap = toDecimal(localCurrentBall?.pin_to_pap, spanMeasurement);
      const mbToPap = toDecimal(localCurrentBall?.psa_to_pap, spanMeasurement);
      const pinToCenter = toDecimal(
        localCurrentBall?.pin_to_center,
        spanMeasurement,
      );

      return isValid2LSLayout({
        pinToPapDistance: pinToPap,
        mbToPapDistance: mbToPap,
        pinToCenter,
        playerPapOffset: { horizontal: papHorizontal, vertical: papVertical },
      });
    }

    if (layoutType === "pal") {
      const pinToPap = toDecimal(localCurrentBall?.pin_to_pap, spanMeasurement);
      const mbToPap = toDecimal(localCurrentBall?.psa_to_pap, spanMeasurement);
      const pinToCenter = toDecimal(
        localCurrentBall?.pin_above_line || localCurrentBall?.pin_to_center,
        spanMeasurement,
      );

      return isValidPALLayout({
        pinToPapDistance: pinToPap,
        mbToPapDistance: mbToPap,
        pinToCenter,
        playerPapOffset: { horizontal: papHorizontal, vertical: papVertical },
      });
    }

    return false;
  }, [localCurrentBall, currentLayout, papV, papH, spanMeasurement]);

  const handleValuesSuggested = (e) => {
    if (isReadOnly) return;
    const value = e.target.value;
    const fieldName = e.target.name;

    const ball = {
      ...localCurrentBall,
      customer_id: selectedCustomer.id,
      id: ballID,
      [fieldName]: value,
    };

    setLocalCurrentBall(setBallLayout(ball.layout_type || currentLayout)(ball));

    ballHandleForm({
      ball,
    });
  };

  const handleBarcodeValues = (e) => {
    if (isReadOnly) return;
    const value = e.serial_number;
    const fieldName = "serial_number";
    const ball = {
      ...localCurrentBall,
      customer_id: selectedCustomer.id,
      id: ballID,
      [fieldName]: value,
    };

    setLocalCurrentBall(setBallLayout(ball.layout_type || currentLayout)(ball));

    ballHandleForm({
      ball,
    });
  };

  const handleConversionValues = (type, layout_value) => {
    if (isReadOnly) return;

    const ball = {
      ...localCurrentBall,
      customer_id: selectedCustomer.id,
      id: ballID,
      layout: layout_value,
      layout_type: type,
    };
    setLocalCurrentBall(setBallLayout(ball.layout_type || currentLayout)(ball));

    ballHandleForm({
      ball,
    });
  };

  const handleValuesLayoutType = ({ value, fieldName }) => {
    if (isReadOnly) return;

    const ball = {
      ...localCurrentBall,
      customer_id: selectedCustomer.id,
      id: ballID,
      [fieldName]: value,
    };

    setLocalCurrentBall(setBallLayout(ball.layout_type || currentLayout)(ball));

    ballHandleForm({
      ball,
    });
  };

  const parseExtraValuesDeep = (v) => {
    if (!v) return {};
    if (typeof v === "object") return v;
    if (typeof v !== "string") return {};
    let curr = v;
    for (let i = 0; i < 20; i++) {
      try {
        const next = JSON.parse(curr);
        if (next && typeof next === "object") return next;
        if (typeof next === "string") {
          curr = next;
          continue;
        }
        return {};
      } catch (_) {
        return {};
      }
    }
    return {};
  };

  const persistInsertColors = (colors) => {
    const cleaned = Object.fromEntries(
      Object.entries(colors || {}).filter(([_, v]) => !!v),
    );
    if (Object.keys(cleaned).length === 0) return;
    const existingEV = parseExtraValuesDeep(currentBall?.extra_values);
    ballHandleForm({
      ball: {
        ...currentBall,
        extra_values: {
          ...existingEV,
          insert_colors: { ...(existingEV.insert_colors || {}), ...cleaned },
        },
      },
    });
  };

  const startAddToOrderFlow = () => {
    setPendingPickerResult(null);
    if (hasAnyInsertVariants(selectedSpecsheet, is2Hander)) {
      setShowInsertPicker(true);
    } else {
      setPendingPickerResult({ colors: {}, slots: {} });
      lastSeenBallCheckSeqRef.current = ball_in_order_check_seq;
      woocommerceCheckBallInOpenOrder({
        first_name: selectedCustomer?.firstname,
        last_name: selectedCustomer?.lastname,
        email: selectedCustomer?.email,
        ball_name: currentBall?.ball_name,
        manufacturer: currentBall?.manufacturer,
        sku: parseExtraValuesDeep(currentBall?.extra_values).barcode || "",
      });
    }
  };

  const handleAddToOrder = (replaceMode) => {
    setShowAddToOrderConfirm(false);
    setShowAddOrReplaceConfirm(false);

    const ev = parseExtraValuesDeep(currentBall?.extra_values);
    const sku = ev.barcode || "";
    if (!sku) {
      setPendingPickerResult(null);
      setShowAlert(true);
      setShowAlertMessage("spectrepos.no_barcode_body");
      setShowAlertHeader("spectrepos.no_barcode_title");
      return;
    }

    const insertSkus = [];
    const slots = pendingPickerResult?.slots || {};
    const colors = pendingPickerResult?.colors || {};
    for (const key of ["f1", "f2"]) {
      const slot = slots[key];
      const color = colors[key];
      if (slot && color) {
        const upc = resolveInsertUpc(slot.typeId, slot.size, color);
        if (upc) insertSkus.push(upc);
      }
    }
    const thmSlot = slots.thm;
    const thmColor = colors.thm;
    if (thmSlot && thmColor) {
      if (thmSlot.category === "simple" && thmColor.slug) {
        const upc = resolveThumbSimpleUpc(
          thmSlot.typeId,
          thmSlot.size,
          thmColor.slug,
        );
        if (upc) insertSkus.push(upc);
      } else if (thmSlot.category === "switch") {
        if (thmColor.slug) {
          const inUpc = resolveThumbSwitchInnerUpc(
            thmSlot.typeId,
            thmSlot.inner_size,
            thmColor.slug,
          );
          if (inUpc) insertSkus.push(inUpc);
        }
        if (thmColor.outer) {
          const outUpc = resolveThumbSwitchOuterUpc(
            thmSlot.typeId,
            thmColor.outer,
          );
          if (outUpc) insertSkus.push(outUpc);
        }
      }
    }

    const existingIds = replaceMode
      ? ball_in_order_check_result?.ballLineItemIds || []
      : [];

    lastSeenOrderEventSeqRef.current = last_woocommerce_order_event_seq;
    try {
      posTabRef.current = window.open("about:blank", "_blank");
    } catch (_) {
      posTabRef.current = null;
    }
    setPendingPosNav(true);
    handleWoocommerceSetup(
      { name: currentBall?.ball_name, manufacturer: currentBall?.manufacturer },
      true,
      currentBall,
      sku,
      insertSkus,
      !!replaceMode,
      existingIds,
    );
    setPendingPickerResult(null);
  };

  const handleWoocommerceSetup = (
    ball,
    ballIsNew,
    currentBallValues,
    sku,
    insertSkus,
    replaceMode,
    existingBallLineItemIds,
  ) => {
    if (ballIsNew) {
      woocommerceCheckUserExists({
        first_name: selectedCustomer?.firstname,
        last_name: selectedCustomer?.lastname,
        email: selectedCustomer?.email,
        spectreCustomer: selectedCustomer,
        nextAction: sku ? "SKU add" : "order",
        sku: sku || undefined,
        ball_name: ball.name,
        manufacturer: ball.manufacturer,
        insertSkus: insertSkus || [],
        replaceMode: !!replaceMode,
        existingBallLineItemIds: existingBallLineItemIds || [],
        orderData: {
          payment_method: "bacs",
          payment_method_title: "Direct Bank Transfer",
          set_paid: false,
          created_via: "woocommerce-pos",
          meta_data: [{ key: "_pos", value: "1" }],
          billing: {
            first_name: selectedCustomer?.firstname,
            last_name: selectedCustomer?.lastname,
            address_1: selectedCustomer?.address,
            address_2: "",
            city: selectedCustomer?.city,
            state: selectedCustomer?.state,
            postcode: selectedCustomer?.postal_code,
            country: selectedCustomer?.country,
            email: selectedCustomer?.email,
            phone: selectedCustomer?.telephone,
          },
          shipping: {
            first_name: selectedCustomer?.firstname,
            last_name: selectedCustomer?.lastname,
            company: "",
            address_1: selectedCustomer?.address,
            address_2: "",
            city: selectedCustomer?.city,
            state: selectedCustomer?.state,
            postcode: selectedCustomer?.postal_code,
            country: selectedCustomer?.country,
          },
        },
        customerData: {
          first_name: selectedCustomer?.firstname,
          last_name: selectedCustomer?.lastname,
          email: selectedCustomer?.email,
          username: selectedCustomer?.telephone,
          billing: {
            first_name: selectedCustomer?.firstname,
            last_name: selectedCustomer?.lastname,
            company: "",
            address_1: selectedCustomer?.address,
            address_2: "",
            city: selectedCustomer?.city,
            state: selectedCustomer?.state,
            postcode: selectedCustomer?.postal_code,
            country: selectedCustomer?.country,
            email: selectedCustomer?.email,
            phone: selectedCustomer?.telephone,
          },
          shipping: {
            first_name: selectedCustomer?.firstname,
            last_name: selectedCustomer?.lastname,
            company: "",
            address_1: selectedCustomer?.address,
            address_2: "",
            city: selectedCustomer?.city,
            state: selectedCustomer?.state,
            postcode: selectedCustomer?.postal_code,
            country: selectedCustomer?.country,
          },
        },
      });
    } else {
      woocommerceCheckUserExists({
        first_name: selectedCustomer?.firstname,
        last_name: selectedCustomer?.lastname,
        email: selectedCustomer?.email,
        spectreCustomer: selectedCustomer,
        nextAction: "replace order",
        ball_name: ball.name,
        manufacturer: ball.manufacturer,
        old_ball_name: currentBallValues.ball_name,
        old_manufacturer: currentBallValues.manufacturer,
        // A shop on HBS swaps by code, not by name.
        hbsSku:
          ball.manufacturer_item_number || ball.barcode || ball.upc || "",
        hbsOldSku:
          parseExtraValuesDeep(currentBallValues?.extra_values).barcode || "",
        orderData: {
          payment_method: "bacs",
          payment_method_title: "Direct Bank Transfer",
          set_paid: false,
          created_via: "woocommerce-pos",
          meta_data: [{ key: "_pos", value: "1" }],
          billing: {
            first_name: selectedCustomer?.firstname,
            last_name: selectedCustomer?.lastname,
            address_1: selectedCustomer?.address,
            address_2: "",
            city: selectedCustomer?.city,
            state: selectedCustomer?.state,
            postcode: selectedCustomer?.postal_code,
            country: selectedCustomer?.country,
            email: selectedCustomer?.email,
            phone: selectedCustomer?.telephone,
          },
          shipping: {
            first_name: selectedCustomer?.firstname,
            last_name: selectedCustomer?.lastname,
            company: "",
            address_1: selectedCustomer?.address,
            address_2: "",
            city: selectedCustomer?.city,
            state: selectedCustomer?.state,
            postcode: selectedCustomer?.postal_code,
            country: selectedCustomer?.country,
          },
        },
        customerData: {
          first_name: selectedCustomer?.firstname,
          last_name: selectedCustomer?.lastname,
          email: selectedCustomer?.email,
          username: selectedCustomer?.telephone,
          billing: {
            first_name: selectedCustomer?.firstname,
            last_name: selectedCustomer?.lastname,
            company: "",
            address_1: selectedCustomer?.address,
            address_2: "",
            city: selectedCustomer?.city,
            state: selectedCustomer?.state,
            postcode: selectedCustomer?.postal_code,
            country: selectedCustomer?.country,
            email: selectedCustomer?.email,
            phone: selectedCustomer?.telephone,
          },
          shipping: {
            first_name: selectedCustomer?.firstname,
            last_name: selectedCustomer?.lastname,
            company: "",
            address_1: selectedCustomer?.address,
            address_2: "",
            city: selectedCustomer?.city,
            state: selectedCustomer?.state,
            postcode: selectedCustomer?.postal_code,
            country: selectedCustomer?.country,
          },
        },
      });
    }
  };

  const handleWoocommerceRemoval = (ball) => {
    woocommerceCheckUserExists({
      first_name: selectedCustomer?.firstname,
      last_name: selectedCustomer?.lastname,
      email: selectedCustomer?.email,
      spectreCustomer: selectedCustomer,
      nextAction: "remove order",
      ball_name: ball.ball_name,
      manufacturer: ball.manufacturer,
      hbsSku: parseExtraValuesDeep(ball?.extra_values).barcode || "",
      orderData: {
        payment_method: "bacs",
        payment_method_title: "Direct Bank Transfer",
        set_paid: false,
        billing: {
          first_name: selectedCustomer?.firstname,
          last_name: selectedCustomer?.lastname,
          address_1: selectedCustomer?.address,
          address_2: "",
          city: selectedCustomer?.city,
          state: selectedCustomer?.state,
          postcode: selectedCustomer?.postal_code,
          country: selectedCustomer?.country,
          email: selectedCustomer?.email,
          phone: selectedCustomer?.telephone,
        },
        shipping: {
          first_name: selectedCustomer?.firstname,
          last_name: selectedCustomer?.lastname,
          company: "",
          address_1: selectedCustomer?.address,
          address_2: "",
          city: selectedCustomer?.city,
          state: selectedCustomer?.state,
          postcode: selectedCustomer?.postal_code,
          country: selectedCustomer?.country,
        },
      },
      customerData: {
        first_name: selectedCustomer?.firstname,
        last_name: selectedCustomer?.lastname,
        email: selectedCustomer?.email,
        username: selectedCustomer?.telephone,
        billing: {
          first_name: selectedCustomer?.firstname,
          last_name: selectedCustomer?.lastname,
          company: "",
          address_1: selectedCustomer?.address,
          address_2: "",
          city: selectedCustomer?.city,
          state: selectedCustomer?.state,
          postcode: selectedCustomer?.postal_code,
          country: selectedCustomer?.country,
          email: selectedCustomer?.email,
          phone: selectedCustomer?.telephone,
        },
        shipping: {
          first_name: selectedCustomer?.firstname,
          last_name: selectedCustomer?.lastname,
          company: "",
          address_1: selectedCustomer?.address,
          address_2: "",
          city: selectedCustomer?.city,
          state: selectedCustomer?.state,
          postcode: selectedCustomer?.postal_code,
          country: selectedCustomer?.country,
        },
      },
    });
  };

  const PinCogLengthSelect = ({ value, onChange, options }) => {
    return (
      <Select
        value={value}
        onChange={onChange}
        options={options}
        className="arsenal-select"
        style={{ width: "100%" }}
        virtual={false}
        onDropdownVisibleChange={(open) => {
          if (open) {
            if (value === "" || !value) {
              setTimeout(() => {
                const activeItem = document.querySelector(
                  `.ant-select-item-option[title="- 3/8"]`,
                );
                activeItem && activeItem.scrollIntoView();
              }, 150);
            }
          }
        }}
      />
    );
  };

  const generatePlaceholderImage = (name, lastName) => {
    const canvas = document.createElement("canvas");
    canvas.width = 64; // Set the width of the canvas
    canvas.height = 64; // Set the height of the canvas
    const ctx = canvas.getContext("2d");

    // Draw the blue background
    ctx.fillStyle = "#00187E"; // Solid blue color
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Set the text style
    ctx.fillStyle = "#FFFFFF"; // White text color
    ctx.font = "bold 28px Poppins"; // Font size and family
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    // Get the first letters of name and lastName
    const initials = `${name?.charAt(0)?.toUpperCase()}${lastName
      ?.charAt(0)
      ?.toUpperCase()}`;

    // Draw the initials in the center of the canvas
    ctx.fillText(initials, canvas.width / 2, canvas.height / 2);

    // Return the canvas as a data URL
    return canvas.toDataURL("image/png");
  };

  const defaultImage = generatePlaceholderImage(
    selectedCustomer?.firstname,
    selectedCustomer?.lastname,
  );

  const updateBallDepth = (fieldName, value) => {
    const updatedBall = {
      ...localCurrentBall,
      [fieldName]: value, // Update the specific depth field
    };

    // Update local state
    setLocalCurrentBall(updatedBall);

    // Dispatch the updated ball to Redux
    ballHandleForm({
      ball: updatedBall,
    });
  };

  const handleConversion = (convertFrom, convertTo) => {
    const radius = 4.294;
    const roundTo = 8;
    const pap_h = toDecimal(papH, spanMeasurement);
    const pap_v = toDecimal(papV, spanMeasurement);

    const pinPap = toDecimal(pin_to_pap, spanMeasurement);
    const psaPap = toDecimal(psa_to_pap, spanMeasurement);
    //Should lightning be rounded? causes some inaccuracies particularly in 2ls conversion
    const lightning =
      radius * Math.acos(Math.cos(pap_h / radius) * Math.cos(pap_v / radius));
    switch (convertFrom) {
      case "dual_angle": {
        const value1 = parseFloat(drilling_angle);
        const value2 = parseFloat(val_angle);
        const psa_to_pap_temp =
          isNaN(value1) || isNaN(pinPap)
            ? ""
            : toFractionRound(
                Math.acos(
                  Math.cos(6.75 / radius) * Math.cos(pinPap / radius) +
                    Math.sin(6.75 / radius) *
                      Math.sin(pinPap / radius) *
                      Math.cos(radians(value1)),
                ) * radius,
                roundTo,
              );

        switch (convertTo) {
          case "dual_angle":
            break;
          case "vls": {
            const pin_buffer_temp =
              isNaN(value2) || isNaN(pinPap)
                ? ""
                : toFractionRound(
                    Math.asin(
                      Math.sin(pinPap / radius) * Math.sin(radians(value2)),
                    ) * radius,
                    roundTo,
                  );
            setTimeout(() => {
              handleConversionValues(
                "vls",
                `${pin_to_pap || ""} X ${psa_to_pap_temp || ""} X ${
                  pin_buffer_temp || ""
                }`,
              );
            }, 100);
            break;
          }
          case "2ls": {
            const pin_to_center_temp =
              papDirection === "Down"
                ? isNaN(value2) || isNaN(pinPap)
                  ? ""
                  : toFractionRound(
                      Math.acos(
                        Math.cos(pinPap / radius) *
                          Math.cos(lightning / radius) +
                          Math.sin(pinPap / radius) *
                            Math.sin(lightning / radius) *
                            Math.cos(
                              radians(
                                degrees(
                                  Math.asin(
                                    Math.sin(pap_h / radius) /
                                      Math.sin(lightning / radius),
                                  ),
                                ) - value2,
                              ),
                            ),
                      ) * radius,
                      roundTo,
                    )
                : papDirection === "Up"
                  ? isNaN(value2) || isNaN(pinPap)
                    ? ""
                    : toFractionRound(
                        Math.acos(
                          Math.cos(pinPap / radius) *
                            Math.cos(lightning / radius) +
                            Math.sin(pinPap / radius) *
                              Math.sin(lightning / radius) *
                              Math.cos(
                                radians(
                                  180 -
                                    degrees(
                                      Math.asin(
                                        Math.sin(pap_h / radius) /
                                          Math.sin(lightning / radius),
                                      ),
                                    ) -
                                    value2,
                                ),
                              ),
                        ) * radius,
                        roundTo,
                      )
                  : "---";
            if (pin_to_center_temp === "---") setShowNoPAPModal(true);
            handleConversionValues(
              "2ls",
              `${pin_to_pap || ""} X ${psa_to_pap_temp || ""} X ${
                pin_to_center_temp || ""
              }`,
            );
            break;
          }

          case "pal": {
            const pin_above_line_temp =
              papDirection === "Down"
                ? isNaN(value2) || isNaN(pinPap)
                  ? ""
                  : toFractionRound(
                      Math.asin(
                        Math.sin(pinPap / radius) *
                          Math.sin(
                            radians(
                              degrees(
                                Math.asin(
                                  Math.sin(pap_h / radius) /
                                    Math.sin(lightning / radius),
                                ),
                              ) - value2,
                            ),
                          ),
                      ) * radius,
                      roundTo,
                    )
                : papDirection === "Up"
                  ? isNaN(value2) || isNaN(pinPap)
                    ? ""
                    : toFractionRound(
                        Math.asin(
                          Math.sin(pinPap / radius) *
                            Math.sin(
                              radians(
                                degrees(
                                  Math.asin(
                                    Math.sin(pap_h / radius) /
                                      Math.sin(lightning / radius),
                                  ),
                                ) + value2,
                              ),
                            ),
                        ) * radius,
                        roundTo,
                      )
                  : "---";
            if (pin_above_line_temp === "---") setShowNoPAPModal(true);

            handleConversionValues(
              "pal",
              `${pin_to_pap || ""} X ${psa_to_pap_temp || ""} X ${
                pin_above_line_temp || ""
              }`,
            );

            break;
          }
        }
        break;
      }
      case "vls": {
        const pinBuffer = toDecimal(pin_buffer, spanMeasurement);
        switch (convertTo) {
          case "dual_angle": {
            const drilling_angle_temp =
              dualAngleMeasurment === "5"
                ? Math.round(
                    degrees(
                      Math.acos(
                        (Math.cos(psaPap / radius) -
                          Math.cos(pinPap / radius) * Math.cos(6.75 / radius)) /
                          (Math.sin(pinPap / radius) * Math.sin(6.75 / radius)),
                      ),
                    ) / 5,
                  ) * 5
                : Math.round(
                    degrees(
                      Math.acos(
                        (Math.cos(psaPap / radius) -
                          Math.cos(pinPap / radius) * Math.cos(6.75 / radius)) /
                          (Math.sin(pinPap / radius) * Math.sin(6.75 / radius)),
                      ),
                    ),
                  );
            const val_angle_temp =
              dualAngleMeasurment === "5"
                ? Math.round(
                    degrees(
                      Math.asin(
                        Math.sin(pinBuffer / radius) /
                          Math.sin(pinPap / radius),
                      ),
                    ) / 5,
                  ) * 5
                : Math.round(
                    degrees(
                      Math.asin(
                        Math.sin(pinBuffer / radius) /
                          Math.sin(pinPap / radius),
                      ),
                    ),
                  );

            handleConversionValues(
              "dual_angle",
              `${drilling_angle_temp || ""} X ${pin_to_pap || ""} X ${
                val_angle_temp || ""
              }`,
            );
            break;
          }
          case "vls": {
            break;
          }
          case "2ls": {
            const safeAsin = (value) =>
              Math.asin(Math.max(-1, Math.min(1, value)));
            const safeAcos = (value) =>
              Math.acos(Math.max(-1, Math.min(1, value)));
            const pin_to_center_temp =
              papDirection === "Down"
                ? isNaN(pinBuffer) || isNaN(pinPap)
                  ? ""
                  : toFractionRound(
                      safeAsin(
                        Math.cos(pinPap / radius) *
                          Math.cos(lightning / radius) +
                          Math.sin(pinPap / radius) *
                            Math.sin(lightning / radius) *
                            Math.cos(
                              radians(
                                degrees(
                                  safeAsin(
                                    Math.sin(pap_h / radius) /
                                      Math.sin(lightning / radius),
                                  ),
                                ) -
                                  degrees(
                                    safeAsin(
                                      Math.sin(pinBuffer / radius) /
                                        Math.sin(pinPap / radius),
                                    ),
                                  ),
                              ),
                            ),
                      ) * radius,
                      roundTo,
                    )
                : papDirection === "Up"
                  ? isNaN(pinBuffer) || isNaN(pinPap)
                    ? ""
                    : toFractionRound(
                        safeAcos(
                          Math.cos(pinPap / radius) *
                            Math.cos(lightning / radius) +
                            Math.sin(pinPap / radius) *
                              Math.sin(lightning / radius) *
                              Math.cos(
                                radians(
                                  180 -
                                    degrees(
                                      safeAsin(
                                        Math.sin(pap_h / radius) /
                                          Math.sin(lightning / radius),
                                      ),
                                    ) -
                                    degrees(
                                      safeAsin(
                                        Math.sin(pinBuffer / radius) /
                                          Math.sin(pinPap / radius),
                                      ),
                                    ),
                                ),
                              ),
                        ) * radius,
                        roundTo,
                      )
                  : "---";
            if (pin_to_center_temp === "---") setShowNoPAPModal(true);
            handleConversionValues(
              "2ls",
              `${pin_to_pap || ""} X ${psa_to_pap || ""} X ${
                pin_to_center_temp || ""
              }`,
            );
            break;
          }
          case "pal": {
            const pin_above_line_temp =
              papDirection === "Down"
                ? isNaN(pinBuffer) || isNaN(pinPap)
                  ? ""
                  : toFractionRound(
                      Math.asin(
                        Math.sin(pinPap / radius) *
                          Math.sin(
                            radians(
                              degrees(
                                Math.asin(
                                  Math.sin(pap_h / radius) /
                                    Math.sin(lightning / radius),
                                ),
                              ) -
                                degrees(
                                  Math.asin(
                                    Math.sin(pinBuffer / radius) /
                                      Math.sin(pinPap / radius),
                                  ),
                                ),
                            ),
                          ),
                      ) * radius,
                      roundTo,
                    ) //Why was there no Val angle used for the up direction? Problem with initial excel file?
                : papDirection === "Up"
                  ? isNaN(pinBuffer) || isNaN(pinPap)
                    ? ""
                    : toFractionRound(
                        Math.asin(
                          Math.sin(pinPap / radius) *
                            Math.sin(
                              radians(
                                degrees(
                                  Math.asin(
                                    Math.sin(pap_h / radius) /
                                      Math.sin(lightning / radius),
                                  ),
                                ) +
                                  degrees(
                                    Math.asin(
                                      Math.sin(pinBuffer / radius) /
                                        Math.sin(pinPap / radius),
                                    ),
                                  ),
                              ),
                            ),
                        ) * radius,
                        roundTo,
                      )
                  : "---";
            if (pin_above_line_temp === "---") setShowNoPAPModal(true);

            handleConversionValues(
              "pal",
              `${pin_to_pap || ""} X ${psa_to_pap || ""} X ${
                pin_above_line_temp || ""
              }`,
            );

            break;
          }
        }
        break;
      }

      case "2ls": {
        const pinToCenter = toDecimal(pin_to_center, spanMeasurement);

        switch (convertTo) {
          case "dual_angle": {
            const drilling_angle_temp =
              dualAngleMeasurment === "5"
                ? Math.round(
                    degrees(
                      Math.acos(
                        (Math.cos(psaPap / radius) -
                          Math.cos(pinPap / radius) * Math.cos(6.75 / radius)) /
                          (Math.sin(pinPap / radius) * Math.sin(6.75 / radius)),
                      ),
                    ) / 5,
                  ) * 5
                : Math.round(
                    degrees(
                      Math.acos(
                        (Math.cos(psaPap / radius) -
                          Math.cos(pinPap / radius) * Math.cos(6.75 / radius)) /
                          (Math.sin(pinPap / radius) * Math.sin(6.75 / radius)),
                      ),
                    ),
                  );

            const val_angle_temp =
              papDirection === "Down"
                ? pinToCenter >= 0
                  ? Math.round(
                      degrees(
                        Math.asin(
                          Math.sin(pap_h / radius) /
                            Math.sin(lightning / radius),
                        ),
                      ) -
                        degrees(
                          Math.acos(
                            (Math.cos(pinToCenter / radius) -
                              Math.cos(pinPap / radius) *
                                Math.cos(lightning / radius)) /
                              (Math.sin(pinPap / radius) *
                                Math.sin(lightning / radius)),
                          ),
                        ),
                    )
                  : Math.round(
                      degrees(
                        Math.asin(
                          Math.sin(pap_h / radius) /
                            Math.sin(lightning / radius),
                        ),
                      ) +
                        degrees(
                          Math.acos(
                            (Math.cos(pinToCenter / radius) -
                              Math.cos(pinPap / radius) *
                                Math.cos(lightning / radius)) /
                              (Math.sin(pinPap / radius) *
                                Math.sin(lightning / radius)),
                          ),
                        ),
                    )
                : papDirection === "Up"
                  ? pinToCenter >= 0
                    ? Math.round(
                        180 -
                          degrees(
                            Math.asin(
                              Math.sin(pap_h / radius) /
                                Math.sin(lightning / radius),
                            ),
                          ) -
                          Math.abs(
                            degrees(
                              Math.acos(
                                (Math.cos(pinToCenter / radius) -
                                  Math.cos(pinPap / radius) *
                                    Math.cos(lightning / radius)) /
                                  (Math.sin(pinPap / radius) *
                                    Math.sin(lightning / radius)),
                              ),
                            ),
                          ),
                      )
                    : Math.round(
                        180 -
                          degrees(
                            Math.asin(
                              Math.sin(pap_h / radius) /
                                Math.sin(lightning / radius),
                            ),
                          ) +
                          degrees(
                            Math.acos(
                              (Math.cos(pinToCenter / radius) -
                                Math.cos(pinPap / radius) *
                                  Math.cos(lightning / radius)) /
                                (Math.sin(pinPap / radius) *
                                  Math.sin(lightning / radius)),
                            ),
                          ),
                      )
                  : "---";

            if (val_angle_temp === "---") setShowNoPAPModal(true);
            dualAngleMeasurment === "5"
              ? handleConversionValues(
                  "dual_angle",
                  `${drilling_angle_temp || ""} X ${pin_to_pap || ""} X ${
                    Math.round(val_angle_temp / 5) * 5 || ""
                  }`,
                )
              : handleConversionValues(
                  "dual_angle",
                  `${drilling_angle_temp || ""} X ${pin_to_pap || ""} X ${
                    Math.round(val_angle_temp) || ""
                  }`,
                );

            break;
          }
          case "vls": {
            const safeAsin = (value) =>
              Math.asin(Math.max(-1, Math.min(1, value)));
            const safeAcos = (value) =>
              Math.acos(Math.max(-1, Math.min(1, value)));
            const pin_buffer_temp =
              papDirection === "Down"
                ? isNaN(pinPap) || isNaN(pinToCenter)
                  ? ""
                  : toFractionRound(
                      safeAsin(
                        Math.sin(pinPap / radius) *
                          Math.sin(
                            radians(
                              degrees(
                                safeAsin(
                                  Math.sin(pap_h / radius) /
                                    Math.sin(lightning / radius),
                                ),
                              ) -
                                degrees(
                                  safeAcos(
                                    (Math.sin(pinToCenter / radius) -
                                      Math.cos(pinPap / radius) *
                                        Math.cos(lightning / radius)) /
                                      (Math.sin(pinPap / radius) *
                                        Math.sin(lightning / radius)),
                                  ),
                                ),
                            ),
                          ),
                      ) * radius,
                      roundTo,
                    )
                : papDirection === "Up"
                  ? isNaN(pinPap) || isNaN(pinToCenter)
                    ? ""
                    : toFractionRound(
                        safeAsin(
                          Math.sin(pinPap / radius) *
                            Math.sin(
                              radians(
                                180 -
                                  degrees(
                                    safeAsin(
                                      Math.sin(pap_h / radius) /
                                        Math.sin(lightning / radius),
                                    ),
                                  ) -
                                  degrees(
                                    safeAcos(
                                      (Math.cos(pinToCenter / radius) -
                                        Math.cos(pinPap / radius) *
                                          Math.cos(lightning / radius)) /
                                        (Math.sin(pinPap / radius) *
                                          Math.sin(lightning / radius)),
                                    ),
                                  ),
                              ),
                            ),
                        ) * radius,
                        roundTo,
                      )
                  : "---";
            if (pin_buffer_temp === "---") setShowNoPAPModal(true);
            handleConversionValues(
              "vls",
              `${pin_to_pap || ""} X ${psa_to_pap || ""} X ${
                pin_buffer_temp || ""
              }`,
            );
            break;
          }
          case "2ls":
            break;
          case "pal": {
            const pin_above_line_temp =
              papDirection === "Down"
                ? isNaN(pinPap) || isNaN(pinToCenter)
                  ? ""
                  : toFractionRound(
                      Math.asin(
                        Math.sin(pinPap / radius) *
                          Math.sin(
                            radians(
                              degrees(
                                Math.asin(
                                  Math.sin(pap_h / radius) /
                                    Math.sin(lightning / radius),
                                ),
                              ) -
                                (degrees(
                                  Math.asin(
                                    Math.sin(pap_h / radius) /
                                      Math.sin(lightning / radius),
                                  ),
                                ) -
                                  degrees(
                                    Math.acos(
                                      (Math.sin(pinToCenter / radius) -
                                        Math.cos(pinPap / radius) *
                                          Math.cos(lightning / radius)) /
                                        (Math.sin(pinPap / radius) *
                                          Math.sin(lightning / radius)),
                                    ),
                                  )),
                            ),
                          ),
                      ) * radius,
                      roundTo,
                    )
                : papDirection === "Up"
                  ? isNaN(pinPap) || isNaN(pinToCenter)
                    ? ""
                    : toFractionRound(
                        Math.asin(
                          Math.sin(pinPap / radius) *
                            Math.sin(
                              radians(
                                degrees(
                                  Math.asin(
                                    Math.sin(pap_h / radius) /
                                      Math.sin(lightning / radius),
                                  ),
                                ) +
                                  180 -
                                  degrees(
                                    Math.asin(
                                      Math.sin(pap_h / radius) /
                                        Math.sin(lightning / radius),
                                    ),
                                  ) -
                                  degrees(
                                    Math.acos(
                                      (Math.cos(pinToCenter / radius) -
                                        Math.cos(pinPap / radius) *
                                          Math.cos(lightning / radius)) /
                                        (Math.sin(pinPap / radius) *
                                          Math.sin(lightning / radius)),
                                    ),
                                  ),
                              ),
                            ),
                        ) * radius,
                        roundTo,
                      )
                  : "---";
            if (pin_above_line_temp === "---") setShowNoPAPModal(true);
            handleConversionValues(
              "pal",
              `${pin_to_pap || ""} X ${psa_to_pap || ""} X ${
                pin_above_line_temp || ""
              }`,
            );
            break;
          }
        }
        break;
      }

      case "pal": {
        const pinAboveLine = toDecimal(pin_above_line, spanMeasurement);
        const val_angle_temp =
          papDirection === "Down"
            ? Math.round(
                degrees(
                  Math.asin(
                    Math.sin(pap_h / radius) / Math.sin(lightning / radius),
                  ),
                ) -
                  degrees(
                    Math.asin(
                      Math.sin(pinAboveLine / radius) /
                        Math.sin(pinPap / radius),
                    ),
                  ),
              )
            : papDirection === "Up"
              ? Math.round(
                  180 -
                    degrees(
                      Math.asin(
                        Math.sin(pap_h / radius) / Math.sin(lightning / radius),
                      ),
                    ) -
                    degrees(
                      Math.asin(
                        Math.sin(pinAboveLine / radius) /
                          Math.sin(pinPap / radius),
                      ),
                    ),
                )
              : "---";
        if (val_angle_temp === "---") setShowNoPAPModal(true);
        switch (convertTo) {
          case "dual_angle": {
            const drilling_angle_temp = degrees(
              Math.acos(
                (Math.cos(psaPap / radius) -
                  Math.cos(pinPap / radius) * Math.cos(6.75 / radius)) /
                  (Math.sin(pinPap / radius) * Math.sin(6.75 / radius)),
              ),
            );
            dualAngleMeasurment === "5"
              ? handleConversionValues(
                  "dual_angle",
                  `${Math.round(drilling_angle_temp / 5) * 5 || ""} X ${
                    pin_to_pap || ""
                  } X ${Math.round(val_angle_temp / 5) * 5 || ""}`,
                )
              : handleConversionValues(
                  "dual_angle",
                  `${Math.round(drilling_angle_temp) || ""} X ${
                    pin_to_pap || ""
                  } X ${Math.round(val_angle_temp) || ""}`,
                );

            break;
          }
          case "vls": {
            const pin_buffer_temp =
              isNaN(pinPap) || isNaN(pinAboveLine)
                ? ""
                : toFractionRound(
                    Math.asin(
                      Math.sin(pinPap / radius) *
                        Math.sin(radians(val_angle_temp)),
                    ) * radius,
                    roundTo,
                  );

            handleConversionValues(
              "vls",
              `${pin_to_pap || ""} X ${psa_to_pap || ""} X ${
                pin_buffer_temp || ""
              }`,
            );
            break;
          }
          case "2ls": {
            const pin_to_center_temp =
              papDirection === "Down"
                ? isNaN(pinPap) || isNaN(pinAboveLine)
                  ? ""
                  : toFractionRound(
                      Math.asin(
                        Math.cos(pinPap / radius) *
                          Math.cos(lightning / radius) +
                          Math.sin(pinPap / radius) *
                            Math.sin(lightning / radius) *
                            Math.cos(
                              radians(
                                degrees(
                                  Math.asin(
                                    Math.sin(pap_h / radius) /
                                      Math.sin(lightning / radius),
                                  ),
                                ) - val_angle_temp,
                              ),
                            ),
                      ) * radius,
                      roundTo,
                    )
                : papDirection === "Up"
                  ? isNaN(pinPap) || isNaN(pinAboveLine)
                    ? ""
                    : toFractionRound(
                        Math.acos(
                          Math.cos(pinPap / radius) *
                            Math.cos(lightning / radius) +
                            Math.sin(pinPap / radius) *
                              Math.sin(lightning / radius) *
                              Math.cos(
                                radians(
                                  180 -
                                    degrees(
                                      Math.asin(
                                        Math.sin(pap_h / radius) /
                                          Math.sin(lightning / radius),
                                      ),
                                    ) -
                                    val_angle_temp,
                                ),
                              ),
                        ) * radius,
                        roundTo,
                      )
                  : "---";
            if (pin_to_center_temp === "---") setShowNoPAPModal(true);
            handleConversionValues(
              "2ls",
              `${pin_to_pap || ""} X ${psa_to_pap || ""} X ${
                pin_to_center_temp || ""
              }`,
            );
            break;
          }
          case "pal":
            break;
        }
        break;
      }
    }
  };

  const handleBallSearch = ({
    filter,
    rangeInitial,
    rangeFinal,
    filters,
    order,
  }) => {
    setShowSearchBallModal(true);
    getBallDatabaseSearch({
      filter,
      rangeInitial,
      rangeFinal,
      filters,
      order,
    });
  };

  useEffect(() => {
    if (localCurrentBall?.id === currentBall?.id) {
      if (localCurrentBall?.photo !== currentBall?.photo) {
        setLocalCurrentBall({
          ...localCurrentBall,
          ...currentBall,
        });
      }
    }
  }, [currentBall?.photo]);

  useEffect(() => {
    if (localCurrentBall) {
      setFirstHoleDepth(localCurrentBall?.f1_depth || 0); // Update firstHoleDepth
      setSecondHoleDepth(localCurrentBall?.f2_depth || 0); // Update secondHoleDepth
      setThumbHoleDepth(localCurrentBall?.thumb_depth || 0); // Update thumbHoleDepth
    }
  }, [localCurrentBall]);

  useEffect(() => {
    if (is2Hander) {
      setThumbHoleDepth(0); // Reset thumbHoleDepth for two-handed bowlers
    }
  }, []);

  const renderLayout = ({ currentLayout }) => {
    switch (currentLayout) {
      case "dual_angle":
        return (
          <>
            <div className="row" style={formDoubleColumnStyle}>
              <div className="col-8 col-md-8 col-lg-4" style={spaceStyle}>
                <FloatingLabel
                  label={t("form.label.drilling_angle")}
                  className="arsenal-select-floating-label"
                >
                  <Select
                    open={isReadOnly ? false : undefined}
                    value={drilling_angle}
                    className="arsenal-select"
                    style={dropdownStyle}
                    onChange={(value) => {
                      handleValuesSuggested({
                        target: {
                          value: `${value || ""} X ${pin_to_pap || ""} X ${
                            val_angle || ""
                          }`,
                          name: "layout",
                        },
                      });
                    }}
                    options={
                      dualAngleMeasurment === "5"
                        ? idx_data_angle.map((angleData) => ({
                            value: angleData.angle,
                            label: angleData.angle,
                          }))
                        : idx_data_angle_1.map((angleData) => ({
                            value: angleData.angle,
                            label: angleData.angle,
                          }))
                    }
                  />
                </FloatingLabel>
              </div>
              <div className="col-8 col-md-8 col-lg-4" style={spaceStyle}>
                <FloatingLabel
                  label={t("form.label.pin_to_pap")}
                  className="arsenal-select-floating-label"
                >
                  <Select
                    open={isReadOnly ? false : undefined}
                    value={pin_to_pap}
                    className="arsenal-select"
                    style={dropdownStyle}
                    onChange={(value) => {
                      handleValuesSuggested({
                        target: {
                          value: `${drilling_angle || ""} X ${value || ""} X ${
                            val_angle || ""
                          }`,
                          name: "layout",
                        },
                      });
                    }}
                    options={idx_data_pap_length.map((papLengthData) => ({
                      value: papLengthData.pap_length,
                      label: papLengthData.pap_length,
                    }))}
                  />
                </FloatingLabel>
              </div>
              <div className="col-8 col-md-8 col-lg-4" style={spaceStyle}>
                <FloatingLabel
                  label={t("form.label.val_angle")}
                  className="arsenal-select-floating-label"
                >
                  <Select
                    open={isReadOnly ? false : undefined}
                    value={val_angle}
                    className="arsenal-select"
                    style={dropdownStyle}
                    onChange={(value) => {
                      handleValuesSuggested({
                        target: {
                          value: `${drilling_angle || ""} X ${
                            pin_to_pap || ""
                          } X ${value || ""}`,
                          name: "layout",
                        },
                      });
                    }}
                    options={
                      dualAngleMeasurment === "5"
                        ? idx_data_angle.map((angleData) => ({
                            value: angleData.angle,
                            label: angleData.angle,
                          }))
                        : idx_data_angle_1.map((angleData) => ({
                            value: angleData.angle,
                            label: angleData.angle,
                          }))
                    }
                  />
                </FloatingLabel>
                {/*Add a new Select somewhere here or on the next row to include the value replacing 6.75 */}
              </div>
            </div>
          </>
        );
      case "vls":
        return (
          <>
            <div className="row" style={formDoubleColumnStyle}>
              <div className="col-8 col-md-8 col-lg-4" style={spaceStyle}>
                <FloatingLabel
                  label={t("form.label.pin_to_pap")}
                  className="arsenal-select-floating-label"
                >
                  <Select
                    open={isReadOnly ? false : undefined}
                    value={pin_to_pap}
                    className="arsenal-select"
                    style={dropdownStyle}
                    onChange={(value) => {
                      handleValuesSuggested({
                        target: {
                          value: `${value || ""} X ${psa_to_pap || ""} X ${
                            pin_buffer || ""
                          }`,
                          name: "layout",
                        },
                      });
                    }}
                    options={idx_data_pap_length
                      .filter((papLengthData) => {
                        const papLengthDecimal = toDecimal(
                          papLengthData.pap_length,
                          "16",
                        );
                        const psaToPapDecimal = toDecimal(psa_to_pap, "16");
                        return (
                          papLengthDecimal + psaToPapDecimal >= 6.75 ||
                          isNaN(psaToPapDecimal) ||
                          isNaN(papLengthDecimal)
                        );
                      })
                      .map((papLengthData) => ({
                        value: papLengthData.pap_length,
                        label: papLengthData.pap_length,
                      }))}
                  />
                </FloatingLabel>
              </div>
              <div className="col-8 col-md-8 col-lg-4" style={spaceStyle}>
                <FloatingLabel
                  label={t("form.label.psa_to_pap")}
                  className="arsenal-select-floating-label"
                >
                  <Select
                    open={isReadOnly ? false : undefined}
                    value={psa_to_pap}
                    className="arsenal-select"
                    style={dropdownStyle}
                    onChange={(value) => {
                      handleValuesSuggested({
                        target: {
                          value: `${pin_to_pap || ""} X ${value || ""} X ${
                            pin_buffer || ""
                          }`,
                          name: "layout",
                        },
                      });
                    }}
                    options={idx_data_pap_length
                      .filter((papLengthData) => {
                        const papLengthDecimal = toDecimal(
                          papLengthData.pap_length,
                          "16",
                        );
                        const pinToPapDecimal = toDecimal(pin_to_pap, "16");
                        return (
                          papLengthDecimal + pinToPapDecimal >= 6.75 ||
                          isNaN(pinToPapDecimal) ||
                          isNaN(papLengthDecimal)
                        );
                      })
                      .map((papLengthData) => ({
                        value: papLengthData.pap_length,
                        label: papLengthData.pap_length,
                      }))}
                  />
                </FloatingLabel>
              </div>
              <div className="col-8 col-md-8 col-lg-4" style={spaceStyle}>
                <FloatingLabel
                  label={t("form.label.pin_buffer")}
                  className="arsenal-select-floating-label"
                >
                  <Select
                    open={isReadOnly ? false : undefined}
                    value={pin_buffer}
                    className="arsenal-select"
                    style={dropdownStyle}
                    onChange={(value) => {
                      handleValuesSuggested({
                        target: {
                          value: `${pin_to_pap || ""} X ${psa_to_pap || ""} X ${
                            value || ""
                          }`,
                          name: "layout",
                        },
                      });
                    }}
                    options={idx_data_pap_length.map((papLengthData) => ({
                      value: papLengthData.pap_length,
                      label: papLengthData.pap_length,
                    }))}
                  />
                </FloatingLabel>
              </div>
            </div>
          </>
        );
      case "2ls":
        return (
          <>
            <div className="row" style={formDoubleColumnStyle}>
              <div className="col-8 col-md-8 col-lg-4" style={spaceStyle}>
                <FloatingLabel
                  label={t("form.label.pin_to_pap")}
                  className="arsenal-select-floating-label"
                >
                  <Select
                    open={isReadOnly ? false : undefined}
                    value={pin_to_pap}
                    className="arsenal-select"
                    style={dropdownStyle}
                    onChange={(value) => {
                      handleValuesSuggested({
                        target: {
                          value: `${value || ""} X ${psa_to_pap || ""} X ${
                            pin_to_center || ""
                          }`,
                          name: "layout",
                        },
                      });
                    }}
                    options={idx_data_pap_length
                      .filter((papLengthData) => {
                        const papLengthDecimal = toDecimal(
                          papLengthData.pap_length,
                          "16",
                        );
                        const psaToPapDecimal = toDecimal(psa_to_pap, "16");
                        const pinToCenterDecimal = toDecimal(
                          pin_to_center,
                          "16",
                        );
                        // Add addtional condition here to ensure pintoPap + pinToCenter >= lightning Line
                        return (
                          (papLengthDecimal + psaToPapDecimal >= 6.75 &&
                            papLengthDecimal + Math.abs(pinToCenterDecimal) >=
                              lightningLine) ||
                          isNaN(psaToPapDecimal) ||
                          isNaN(papLengthDecimal) ||
                          isNaN(pinToCenterDecimal)
                        );
                      })
                      .map((papLengthData) => ({
                        value: papLengthData.pap_length,
                        label: papLengthData.pap_length,
                      }))}
                  />
                </FloatingLabel>
              </div>
              <div className="col-8 col-md-8 col-lg-4" style={spaceStyle}>
                <FloatingLabel
                  label={t("form.label.psa_to_pap")}
                  className="arsenal-select-floating-label"
                >
                  <Select
                    open={isReadOnly ? false : undefined}
                    value={psa_to_pap}
                    className="arsenal-select"
                    style={dropdownStyle}
                    onChange={(value) => {
                      handleValuesSuggested({
                        target: {
                          value: `${pin_to_pap || ""} X ${value || ""} X ${
                            pin_to_center || ""
                          }`,
                          name: "layout",
                        },
                      });
                    }}
                    options={idx_data_pap_length
                      .filter((papLengthData) => {
                        const papLengthDecimal = toDecimal(
                          papLengthData.pap_length,
                          "16",
                        );
                        const pinToPapDecimal = toDecimal(pin_to_pap, "16");
                        return (
                          papLengthDecimal + pinToPapDecimal >= 6.75 ||
                          isNaN(pinToPapDecimal) ||
                          isNaN(papLengthDecimal)
                        );
                      })
                      .map((papLengthData) => ({
                        value: papLengthData.pap_length,
                        label: papLengthData.pap_length,
                      }))}
                  />
                </FloatingLabel>
              </div>
              <div className="col-8 col-md-8 col-lg-4" style={spaceStyle}>
                <FloatingLabel
                  label={t("form.label.pin_to_center_grip")}
                  className="arsenal-select-floating-label"
                >
                  <PinCogLengthSelect
                    open={isReadOnly ? false : undefined}
                    value={pin_to_center}
                    className="arsenal-select"
                    style={dropdownStyle}
                    onChange={(value) => {
                      handleValuesSuggested({
                        target: {
                          value: `${pin_to_pap || ""} X ${psa_to_pap || ""} X ${
                            value || ""
                          }`,
                          name: "layout",
                        },
                      });
                    }}
                    options={idx_data_pin_cog_length
                      .filter((papLengthData) => {
                        const papLengthDecimal = toDecimal(pin_to_pap, "16");
                        const pinToCenterDecimal = toDecimal(
                          papLengthData.pap_length,
                          "16",
                        );
                        // Add addtional condition here to ensure pintoPap + pinToCenter >= lightning Line
                        return (
                          papLengthDecimal + Math.abs(pinToCenterDecimal) >=
                            lightningLine ||
                          isNaN(papLengthDecimal) ||
                          isNaN(pinToCenterDecimal)
                        );
                      })
                      .map((papLengthData) => ({
                        value: papLengthData.pap_length,
                        label: papLengthData.pap_length,
                        "aria-label": papLengthData.pap_length,
                      }))}
                  />
                </FloatingLabel>
              </div>
            </div>
          </>
        );
      case "pal":
        return (
          <>
            <div className="row" style={formDoubleColumnStyle}>
              <div className="col-8 col-md-8 col-lg-4" style={spaceStyle}>
                <FloatingLabel
                  label={t("form.label.pin_to_pap")}
                  className="arsenal-select-floating-label"
                >
                  <Select
                    open={isReadOnly ? false : undefined}
                    value={pin_to_pap}
                    className="arsenal-select"
                    style={dropdownStyle}
                    onChange={(value) => {
                      handleValuesSuggested({
                        target: {
                          value: `${value || ""} X ${psa_to_pap || ""} X ${
                            pin_above_line || ""
                          }`,
                          name: "layout",
                        },
                      });
                    }}
                    options={idx_data_pap_length
                      .filter((papLengthData) => {
                        const papLengthDecimal = toDecimal(
                          papLengthData.pap_length,
                          "16",
                        );
                        const psaToPapDecimal = toDecimal(psa_to_pap, "16");
                        return (
                          papLengthDecimal + psaToPapDecimal >= 6.75 ||
                          isNaN(psaToPapDecimal) ||
                          isNaN(papLengthDecimal)
                        );
                      })
                      .map((papLengthData) => ({
                        value: papLengthData.pap_length,
                        label: papLengthData.pap_length,
                      }))}
                  />
                </FloatingLabel>
              </div>
              <div className="col-8 col-md-8 col-lg-4" style={spaceStyle}>
                <FloatingLabel
                  label={t("form.label.psa_to_pap")}
                  className="arsenal-select-floating-label"
                >
                  <Select
                    open={isReadOnly ? false : undefined}
                    value={psa_to_pap}
                    className="arsenal-select"
                    style={dropdownStyle}
                    onChange={(value) => {
                      handleValuesSuggested({
                        target: {
                          value: `${pin_to_pap || ""} X ${value || ""} X ${
                            pin_above_line || ""
                          }`,
                          name: "layout",
                        },
                      });
                    }}
                    options={idx_data_pap_length
                      .filter((papLengthData) => {
                        const papLengthDecimal = toDecimal(
                          papLengthData.pap_length,
                          "16",
                        );
                        const pinToPapDecimal = toDecimal(pin_to_pap, "16");
                        return (
                          papLengthDecimal + pinToPapDecimal >= 6.75 ||
                          isNaN(pinToPapDecimal) ||
                          isNaN(papLengthDecimal)
                        );
                      })
                      .map((papLengthData) => ({
                        value: papLengthData.pap_length,
                        label: papLengthData.pap_length,
                      }))}
                  />
                </FloatingLabel>
              </div>
              <div className="col-8 col-md-8 col-lg-4" style={spaceStyle}>
                <FloatingLabel
                  label={t("form.label.pin_above_line")}
                  className="arsenal-select-floating-label"
                >
                  <Select
                    open={isReadOnly ? false : undefined}
                    value={pin_above_line}
                    className="arsenal-select"
                    style={dropdownStyle}
                    onChange={(value) => {
                      handleValuesSuggested({
                        target: {
                          value: `${pin_to_pap || ""} X ${psa_to_pap || ""} X ${
                            value || ""
                          }`,
                          name: "layout",
                        },
                      });
                    }}
                    options={idx_data_pap_length.map((papLengthData) => ({
                      value: papLengthData.pap_length,
                      label: papLengthData.pap_length,
                    }))}
                  />
                </FloatingLabel>
              </div>
            </div>
          </>
        );
      case "none":
      default:
        return (
          <Form.Group controlId="formBasicText">
            <div className="row" style={formDoubleColumnStyle}>
              <div className="col-24 col-md-24 col-lg-12" style={spaceStyle}>
                <FloatingLabel
                  controlId="floatingPassword"
                  label={t("form.placeholder.layout")}
                >
                  <Form.Control
                    readOnly={isReadOnly}
                    type="text"
                    name={"layout"}
                    placeholder={t("form.placeholder.layout")}
                    value={layout}
                    as={DebounceInput}
                    onChange={handleValues}
                    {...DEBOUNCE_INPUT_PROPS}
                  />
                </FloatingLabel>
              </div>
            </div>
          </Form.Group>
        );
    }
  };

  return loadingCustomer && balls_drilled.length === 0 ? (
    <Spinner />
  ) : (
    <>
      {!settingBallDatabaseInfo && (
        <BowlerHeader
          actions={
            <HeaderActionButton
              secondary
              onClick={() => navigate("/arsenal/" + bowlerID)}
            >
              <img
                src={ball_icon_blue}
                alt=""
                style={{ width: 16, height: 16 }}
              />
              {t("View All")}
            </HeaderActionButton>
          }
        />
      )}
      <div style={marginRules}>
        {settingBallDatabaseInfo && <Spinner />}
        {!settingBallDatabaseInfo && (
          <>
            <BallActionsBar>
              <HeaderActionButton onClick={handleAddBall}>
                {t("form.label.add_ball")}
              </HeaderActionButton>
              {pluginSubscriptions.indexOf("JOB_BOARD") >= 0 && (
                <HeaderActionButton
                  onClick={() => {
                    if (require_serial_number && serial_number === "") {
                      setHasError(true);
                      setShowNoSerialNumberAlert(true);
                      return;
                    }
                    setHasError(false);
                    createJob({});
                  }}
                >
                  <FileText /> {t("jobBoard.create")}
                </HeaderActionButton>
              )}
              {pluginSubscriptions.indexOf("SPECTRE_POS") >= 0 &&
                posSendFromSpectre &&
                currentBall?.ball_name &&
                currentBall?.manufacturer && (
                  <HeaderActionButton onClick={startAddToOrderFlow}>
                    <CartPlus /> {t("spectrepos.add_to_order")}
                  </HeaderActionButton>
                )}
              <HeaderActionButton
                secondary
                onClick={() => setShowPdfPreview(true)}
              >
                <Printer /> {t("Print")}
              </HeaderActionButton>
              {!isReadOnly && (
                <HeaderActionButton
                  danger
                  onClick={() => setShowConfirmDeleteArsenal(true)}
                >
                  {t("form.label.delete_ball")}
                </HeaderActionButton>
              )}
            </BallActionsBar>
            <BallContainerInfo>
              <BallInfo
                className={`col-12 col-md-12 col-lg-${
                  deviceInfo.isPortrait ? "12" : "6"
                }`}
              >
                {pluginSubscriptions.indexOf("BOWLING_DATABASE") >= 0 && (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Form.Label>
                      {" "}
                      {t("form.label.arsenal_plus_scan_search")}
                    </Form.Label>
                    <div
                      style={{
                        display: "flex",
                        paddingLeft: 0,
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                      }}
                    >
                      <div
                        className="row"
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "flex-start",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            ...spaceStyle, // Apply the shared spaceStyle
                            display: "flex",
                            height: "48px",

                            justifyContent: "center",
                            position: "relative",
                            alignItems: "center",
                            borderRadius: "20px 20px 20px 20px", // Keep the existing borderRadius
                          }}
                        >
                          <FloatingLabel
                            controlId="floatingPassword"
                            label={t("form.placeholder.search_ball")}
                            style={{ width: "100%", height: "48px" }}
                          >
                            <BallDatabaseSearchInput
                              style={{ paddingRight: "20px" }}
                              className="arsenal-select"
                              type="text"
                              onChange={(e) => setBallSearch(e.target.value)}
                              placeholder={t("form.placeholder.search_ball")}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  if (ballSearch.length > 0) {
                                    getBallDatabaseInfoScan({ q: ballSearch });
                                  } else {
                                    setOpenBallDatabaseSearch({ open: true });
                                  }
                                }
                              }}
                            />
                          </FloatingLabel>
                          <ButtonIcon
                            variant="outline-success"
                            style={{ marginRight: "10px", marginLeft: "10px" }}
                            onClick={() => {
                              if (ballSearch.length > 0) {
                                getBallDatabaseInfoScan({ q: ballSearch });
                              } else {
                                setOpenBallDatabaseSearch({ open: true });
                              }
                            }}
                          >
                            <Search />
                          </ButtonIcon>

                          <ButtonIcon
                            variant="secondary"
                            onClick={() => {
                              readBarcode();
                            }}
                          >
                            <UpcScan />
                          </ButtonIcon>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <Form.Label> {t("form.label.ball_info")}</Form.Label>
                <Form>
                  <Form.Group controlId="formBasicText">
                    <div className="row" style={formDoubleColumnStyle}>
                      <div
                        className="col-6 col-md-6 col-lg-6"
                        style={{
                          ...spaceStyle,
                          display: "flex",
                          height: "48px",
                          justifyContent: "center",
                          position: "relative",
                          alignItems: "center",
                        }}
                      >
                        <FloatingLabel
                          controlId="floatingPassword"
                          label={t("form.placeholder.ball_name")}
                          style={{ width: "100%", height: "48px" }}
                        >
                          <Form.Control
                            readOnly={isReadOnly}
                            type="text"
                            name={"ball_name"}
                            placeholder={t("form.placeholder.ball_name")}
                            value={ball_name}
                            as={DebounceInput}
                            onChange={handleValues}
                            {...DEBOUNCE_INPUT_PROPS}
                          />
                        </FloatingLabel>
                      </div>
                      <div
                        className={`col-6 col-md-6 col-lg-6`}
                        style={{
                          ...spaceStyle,
                          display: "flex",
                          height: "48px",
                          justifyContent: "center",
                          position: "relative",
                          alignItems: "center",
                        }}
                      >
                        <FloatingLabel
                          controlId="floatingPassword"
                          label={t("form.placeholder.serial_number")}
                          style={{
                            paddingLeft: 0,
                            width: "100%",
                            height: "48px",
                            color:
                              hasError &&
                              require_serial_number &&
                              (serial_number === "" || !serial_number)
                                ? "red"
                                : "#00197B",
                          }}
                        >
                          <Form.Control
                            readOnly={isReadOnly}
                            type="text"
                            name={"serial_number"}
                            placeholder={t("form.placeholder.serial_number")}
                            value={serial_number}
                            as={DebounceInput}
                            onChange={handleValues}
                            {...DEBOUNCE_INPUT_PROPS}
                          />
                        </FloatingLabel>
                        {pluginSubscriptions.indexOf("BOWLING_DATABASE") >=
                          0 && (
                          <div
                            style={{
                              position: "absolute",
                              right: 17,
                            }}
                          >
                            <ButtonIcon
                              variant="secondary"
                              onClick={() => {
                                setReadingSerialNumber(true);
                              }}
                            >
                              <AspectRatio />
                            </ButtonIcon>
                          </div>
                        )}
                      </div>
                    </div>
                  </Form.Group>
                  <div className="row">
                    <div
                      className="col-6 col-md-6 col-lg-6"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        position: "relative",
                        alignItems: "center",
                      }}
                    >
                      <FloatingLabel
                        label={t("Manufacturer")}
                        className="arsenal-select-floating-label"
                        style={{ width: "100%" }}
                      >
                        <Select
                          open={isReadOnly ? false : undefined}
                          value={manufacturer}
                          className="arsenal-select"
                          style={dropdownStyle}
                          onChange={(value) => {
                            handleValuesSuggested({
                              target: {
                                value,
                                name: "manufacturer",
                              },
                            });
                          }}
                          options={idx_data_ball_manufacturer.map(
                            (manufacturerData) => ({
                              value: manufacturerData.manufacturer,
                              label: manufacturerData.manufacturer,
                            }),
                          )}
                        />
                      </FloatingLabel>
                    </div>
                    <div
                      className="col-6 col-md-6 col-lg-6"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        position: "relative",
                        alignItems: "center",
                      }}
                    >
                      <FloatingLabel
                        label={t("Weight")}
                        className="arsenal-select-floating-label"
                        style={{ width: "100%" }}
                      >
                        <Select
                          open={isReadOnly ? false : undefined}
                          value={weight}
                          className="arsenal-select"
                          style={dropdownStyle}
                          onChange={(value) => {
                            handleValuesSuggested({
                              target: {
                                value,
                                name: "weight",
                              },
                            });
                          }}
                          options={idx_data_ball_weight.map((weightData) => ({
                            value: weightData.weight,
                            label: weightData.weight,
                          }))}
                        />
                      </FloatingLabel>
                    </div>
                  </div>
                  <div className="row">
                    <div
                      className="col-6 col-md-6 col-lg-6"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        position: "relative",
                        alignItems: "center",
                      }}
                    >
                      <FloatingLabel
                        label={t("Spec Sheet Used")}
                        className="arsenal-select-floating-label"
                        style={{ width: "100%" }}
                      >
                        <Select
                          open={isReadOnly ? false : undefined}
                          value={spec_sheet?.id || spec_sheet_id}
                          className="arsenal-select"
                          style={dropdownStyle}
                          onChange={(value) => {
                            handleValuesSuggested({
                              target: {
                                value,
                                name: "spec_sheet_id",
                              },
                            });
                          }}
                          options={specsheets.map((specsheetData) => ({
                            value: specsheetData.id,
                            label: `${moment(specsheetData.created_at).format(
                              "L",
                            )} - ${specsheetData.name || t("no name")}`,
                          }))}
                        />
                      </FloatingLabel>
                    </div>
                    <div
                      className="col-6 col-md-6 col-lg-6"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        position: "relative",
                        alignItems: "flex-start",
                      }}
                    >
                      <DateDrilledContainer className="arsenal-select-floating-label">
                        <DateDrilledTitle>{t("Date drilled")}</DateDrilledTitle>
                        <DateTimePickerInput
                          calendarIcon={
                            <img src={calendarIcon} alt="calendar range" />
                          }
                          onChange={(value) => {
                            handleValuesSuggested({
                              target: {
                                value: moment(value),
                                name: "date_drilled",
                              },
                            });
                          }}
                          value={
                            date_drilled ? new Date(date_drilled) : new Date()
                          }
                          disableClock={true}
                          format={"dd MMM yyyy"}
                          monthAriaLabel="Month"
                          style={{ width: 400 }}
                        />
                      </DateDrilledContainer>
                    </div>
                  </div>

                  <Form.Label style={{ width: "100%" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ maxWidth: "25%" }}>
                        {t("form.label.layout_surface")}
                      </div>
                      <div>
                        {havePap && (
                          <SectionLayoutType big>
                            <ButtonLayoutType
                              left
                              reduceSize
                              type="button"
                              onClick={() => {
                                if (
                                  pluginSubscriptions.indexOf(
                                    "BOWLING_DATABASE",
                                  ) >= 0 &&
                                  convertSettings &&
                                  (layout_type || currentLayout) !== "none" &&
                                  (layout_type || currentLayout) !==
                                    "dual_angle"
                                ) {
                                  setConvertTo("dual_angle");
                                  setShowConversionModal(true);
                                } else {
                                  handleValuesLayoutType({
                                    value: "dual_angle",
                                    fieldName: "layout_type",
                                  });
                                }
                              }}
                              active={
                                layout_type
                                  ? layout_type === "dual_angle"
                                  : currentLayout === "dual_angle"
                                    ? true
                                    : false
                              }
                              name="layout_type"
                              value="dual_angle"
                            >
                              {t("form.setting.dual_angle")}
                            </ButtonLayoutType>
                            <ButtonLayoutType
                              type="button"
                              onClick={() => {
                                if (
                                  pluginSubscriptions.indexOf(
                                    "BOWLING_DATABASE",
                                  ) >= 0 &&
                                  convertSettings &&
                                  (layout_type || currentLayout) !== "none" &&
                                  (layout_type || currentLayout) !== "vls"
                                ) {
                                  setConvertTo("vls");
                                  setShowConversionModal(true);
                                } else {
                                  handleValuesLayoutType({
                                    value: "vls",
                                    fieldName: "layout_type",
                                  });
                                }
                              }}
                              active={
                                layout_type
                                  ? layout_type === "vls"
                                  : currentLayout === "vls"
                                    ? true
                                    : false
                              }
                              name="layout_type"
                              value="vls"
                            >
                              VLS
                            </ButtonLayoutType>

                            {is2Hander && (
                              <ButtonLayoutType
                                type="button"
                                onClick={() => {
                                  if (
                                    pluginSubscriptions.indexOf(
                                      "BOWLING_DATABASE",
                                    ) >= 0 &&
                                    convertSettings &&
                                    (layout_type || currentLayout) !== "none" &&
                                    (layout_type || currentLayout) !== "2ls"
                                  ) {
                                    setConvertTo("2ls");
                                    setShowConversionModal(true);
                                  } else {
                                    handleValuesLayoutType({
                                      value: "2ls",
                                      fieldName: "layout_type",
                                    });
                                  }
                                }}
                                active={
                                  layout_type
                                    ? layout_type === "2ls"
                                    : currentLayout === "2ls"
                                      ? true
                                      : false
                                }
                                name="layout_type"
                                value="2ls"
                              >
                                2LS
                              </ButtonLayoutType>
                            )}
                            {is2Hander && (
                              <ButtonLayoutType
                                type="button"
                                onClick={() => {
                                  if (
                                    pluginSubscriptions.indexOf(
                                      "BOWLING_DATABASE",
                                    ) >= 0 &&
                                    convertSettings &&
                                    (layout_type || currentLayout) !== "none" &&
                                    (layout_type || currentLayout) !== "pal"
                                  ) {
                                    setConvertTo("pal");
                                    setShowConversionModal(true);
                                  } else {
                                    handleValuesLayoutType({
                                      value: "pal",
                                      fieldName: "layout_type",
                                    });
                                  }
                                }}
                                active={
                                  layout_type
                                    ? layout_type === "pal"
                                    : currentLayout === "pal"
                                      ? true
                                      : false
                                }
                                name="layout_type"
                                value="pal"
                              >
                                PAL
                              </ButtonLayoutType>
                            )}
                            <ButtonLayoutType
                              right
                              type="button"
                              onClick={() => {
                                handleValuesLayoutType({
                                  value: "none",
                                  fieldName: "layout_type",
                                });
                              }}
                              active={
                                layout_type
                                  ? layout_type === "none"
                                  : currentLayout === "none"
                                    ? true
                                    : false
                              }
                              name="layout_type"
                              value="none"
                            >
                              NONE
                            </ButtonLayoutType>
                            <DescriptionTextLayoutType>
                              {t("form.label.layout_type")}
                            </DescriptionTextLayoutType>
                          </SectionLayoutType>
                        )}
                      </div>
                    </div>
                  </Form.Label>
                  {showSuggestedLayouts && havePap && (
                    <FloatingLabel
                      label={t("form.label.suggested_layout")}
                      className="arsenal-select-floating-label"
                    >
                      <Select
                        className="arsenal-select"
                        style={dropdownStyle}
                        onChange={(value) => {
                          handleValuesSuggested({
                            target: {
                              value,
                              name: "suggested_layout",
                            },
                          });
                          handleValuesSuggested({
                            target: {
                              value: value,
                              name: "layout",
                            },
                          });
                        }}
                        options={idx_data_suggested_layout
                          .filter((entry) => {
                            return (
                              currentBall?.layout_type === entry.layoutType ||
                              (currentBall?.layout_type !== entry.layoutType &&
                                currentBall?.layout_type === "none") ||
                              (currentBall?.layout_type === "" &&
                                entry.layoutType === currentLayout) ||
                              (currentBall?.layout_type === "" &&
                                currentLayout !== entry.layoutType &&
                                currentLayout === "none")
                            );
                          })
                          .map((suggestedLayoutData) => ({
                            value: suggestedLayoutData.value,
                            label: t(suggestedLayoutData.name),
                          }))}
                      />
                    </FloatingLabel>
                  )}
                  {renderLayout({
                    currentLayout: havePap
                      ? layout_type || currentLayout
                      : "none",
                  })}
                  {layout_type === "2ls" && (
                    <Label
                      style={{
                        color: "#00197B",
                        marginLeft: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {t("Lightning Line: ") +
                        toFractionRound(lightningLine, 8)}
                    </Label>
                  )}
                  <FloatingLabel
                    label={t("Surface")}
                    className="arsenal-select-floating-label"
                  >
                    <Select
                      open={isReadOnly ? false : undefined}
                      value={surface_preparation}
                      className="arsenal-select"
                      style={dropdownStyle}
                      onChange={(value) => {
                        handleValuesSuggested({
                          target: {
                            value,
                            name: "surface_preparation",
                          },
                        });
                      }}
                      options={idx_data_surface.map((surfaceData) => ({
                        value: surfaceData.surface,
                        label: surfaceData.surface,
                      }))}
                    />
                  </FloatingLabel>

                  {pluginSubscriptions.indexOf("BOWLING_DATABASE") >= 0 && (
                    <>
                      <Form.Label>
                        {t("form.label.ball_technical_data")}
                      </Form.Label>
                      <div
                        className="col-12 col-md-12 col-lg-12"
                        style={{
                          ...spaceStyle,
                          display: "flex",
                          justifyContent: "space-between",
                          position: "relative",
                          alignItems: "center",
                        }}
                      >
                        <div
                          className="col-4 col-md-4 col-lg-4"
                          style={{ paddingRight: "5px" }}
                        >
                          <FloatingLabel
                            label={t("form.label.RG")}
                            className="arsenal-select-floating-label"
                          >
                            <Form.Control
                              readOnly={false}
                              type="number"
                              name={"rg"}
                              placeholder={t("form.placeholder.rg")}
                              value={rg}
                              as={DebounceInput}
                              onChange={handleValues}
                              style={{ backgroundColor: "white" }}
                              {...DEBOUNCE_INPUT_PROPS}
                            />
                          </FloatingLabel>
                        </div>
                        <div
                          className="col-4 col-md-4 col-lg-4"
                          style={{ paddingRight: "5px", paddingLeft: "5px" }}
                        >
                          <FloatingLabel
                            label={t("form.label.DIFF")}
                            className="arsenal-select-floating-label"
                          >
                            <Form.Control
                              readOnly={false}
                              type="number"
                              name={"diff"}
                              placeholder={t("form.placeholder.diff")}
                              value={diff}
                              as={DebounceInput}
                              onChange={handleValues}
                              style={{ backgroundColor: "white" }}
                              {...DEBOUNCE_INPUT_PROPS}
                            />
                          </FloatingLabel>
                        </div>
                        <div
                          className="col-4 col-md-4 col-lg-4"
                          style={{ paddingLeft: "5px" }}
                        >
                          <FloatingLabel
                            label={t("form.label.INT_DIFF")}
                            className="arsenal-select-floating-label"
                          >
                            <Form.Control
                              readOnly={false}
                              type="number"
                              name={"int_diff"}
                              placeholder={t("form.placeholder.int_diff")}
                              value={int_diff}
                              as={DebounceInput}
                              onChange={handleValues}
                              style={{ backgroundColor: "white" }}
                              {...DEBOUNCE_INPUT_PROPS}
                            />
                          </FloatingLabel>
                        </div>
                      </div>
                      <div
                        className="col-12 col-md-12 col-lg-12"
                        style={spaceStyle}
                      >
                        <FloatingLabel
                          label={t("form.label.core")}
                          className="arsenal-select-floating-label"
                        >
                          <Form.Control
                            readOnly={false}
                            type="text"
                            name={"core"}
                            placeholder={t("form.placeholder.core")}
                            value={core}
                            as={DebounceInput}
                            onChange={handleValues}
                            style={{ backgroundColor: "white" }}
                            {...DEBOUNCE_INPUT_PROPS}
                          />
                        </FloatingLabel>
                      </div>

                      <div
                        className="col-12 col-md-12 col-lg-12"
                        style={spaceStyle}
                      >
                        <FloatingLabel
                          label={t("form.label.cover")}
                          className="arsenal-select-floating-label"
                        >
                          <Form.Control
                            readOnly={false}
                            type="text"
                            name={"cover"}
                            placeholder={t("form.placeholder.cover")}
                            value={cover}
                            as={DebounceInput}
                            onChange={handleValues}
                            style={{ backgroundColor: "white" }}
                            {...DEBOUNCE_INPUT_PROPS}
                          />
                        </FloatingLabel>
                      </div>
                    </>
                  )}
                  <Form.Label>
                    {t("form.label.weight_hole")}
                    {!haveWeightHole && (
                      <ButtonEye
                        type="button"
                        onClick={() => {
                          setShowWeightHole(!showWeightHole);
                        }}
                      >
                        <EyeOutlined
                          style={{ fontSize: 18, verticalAlign: "-0.03em" }}
                        />
                      </ButtonEye>
                    )}
                  </Form.Label>
                  {(haveWeightHole || showWeightHole) && (
                    <div className="row" style={formDoubleColumnStyle}>
                      <div
                        className="col-12 col-md-4 col-lg-6"
                        style={spaceStyle}
                      >
                        <FloatingLabel
                          label={t("Position")}
                          className="arsenal-select-floating-label"
                        >
                          <Select
                            open={isReadOnly ? false : undefined}
                            value={weight_hole_position}
                            className="arsenal-select"
                            style={dropdownStyle}
                            onChange={(value) => {
                              handleValuesSuggested({
                                target: {
                                  value,
                                  name: "weight_hole_position",
                                },
                              });
                            }}
                            options={idx_data_weight_hole_position.map(
                              (weightHolePositionData) => ({
                                value: weightHolePositionData.position,
                                label: weightHolePositionData.position,
                              }),
                            )}
                          />
                        </FloatingLabel>
                      </div>
                      <div
                        className="col-12 col-md-4 col-lg-3"
                        style={spaceStyle}
                      >
                        <FloatingLabel
                          label={t("Size")}
                          className="arsenal-select-floating-label"
                        >
                          <Select
                            open={isReadOnly ? false : undefined}
                            value={weight_hole_size}
                            className="arsenal-select"
                            style={dropdownStyle}
                            onChange={(value) => {
                              handleValuesSuggested({
                                target: {
                                  value,
                                  name: "weight_hole_size",
                                },
                              });
                            }}
                            options={idx_data_hole_sizes.map(
                              (weightHoleSizeData) => ({
                                value: weightHoleSizeData.size,
                                label: weightHoleSizeData.size,
                              }),
                            )}
                          />
                        </FloatingLabel>
                      </div>
                      <div
                        className="col-12 col-md-4 col-lg-3"
                        style={spaceStyle}
                      >
                        <FloatingLabel
                          label={t("Depth")}
                          className="arsenal-select-floating-label"
                        >
                          <Select
                            open={isReadOnly ? false : undefined}
                            value={weight_hole_depth}
                            className="arsenal-select"
                            style={dropdownStyle}
                            onChange={(value) => {
                              handleValuesSuggested({
                                target: {
                                  value,
                                  name: "weight_hole_depth",
                                },
                              });
                            }}
                            options={idx_data_weight_hole_depth.map(
                              (weightHoleDepthData) => ({
                                value: weightHoleDepthData.depth,
                                label: weightHoleDepthData.depth,
                              }),
                            )}
                          />
                        </FloatingLabel>
                      </div>
                    </div>
                  )}
                  <Form.Label style={{ width: "100%" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>{t("form.label.notes")}</div>
                    </div>
                  </Form.Label>
                  <div className="col-12 col-lg-12">
                    {!isSSR && (
                      <React.Suspense fallback={<Spinner />}>
                        <BallFormNoteLazy />
                      </React.Suspense>
                    )}
                  </div>
                </Form>
              </BallInfo>
              <ImageContainer
                className={`col-12 col-md-12 col-lg-${
                  deviceInfo.isPortrait ? "12" : "6"
                }`}
              >
                {!savingPhoto && (
                  <ImageDiv style={{ position: "relative" }}>
                    {show3D ? (
                      <div
                        style={{
                          width: "100%",
                          height: "unset",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <BallGLView
                          layoutType={
                            localCurrentBall?.layout_type || currentLayout
                          }
                          pinToPapDistance={localCurrentBall?.pin_to_pap}
                          pinAngle={localCurrentBall?.drilling_angle}
                          valAngle={localCurrentBall?.val_angle}
                          pinBuffer={localCurrentBall?.pin_buffer}
                          pinToCenter={localCurrentBall?.pin_to_center}
                          pinAboveLine={localCurrentBall?.pin_above_line}
                          mbToPapDistance={localCurrentBall?.psa_to_pap}
                          playerPapOffset={{
                            vertical: papV,
                            horizontal: papH,
                            direction: papDirection,
                          }}
                          spanMeasurements={{
                            spanMiddleFingerCutToCutDistance:
                              selectedSpecsheet?.f1_span_full,
                            spanRingFingerCutToCutDistance:
                              selectedSpecsheet?.f2_span_full,
                            thumbDiameter:
                              selectedSpecsheet?.thm_od &&
                              selectedSpecsheet?.thm_od !== ""
                                ? selectedSpecsheet?.thm_od
                                : selectedSpecsheet?.thm_starting_bit,
                            middleFingerDiameter:
                              selectedSpecsheet?.f1_od &&
                              selectedSpecsheet?.f1_od !== ""
                                ? selectedSpecsheet?.f1_od
                                : selectedSpecsheet?.f1_size,
                            ringFingerDiameter:
                              selectedSpecsheet?.f2_od &&
                              selectedSpecsheet?.f2_od !== ""
                                ? selectedSpecsheet?.f2_od
                                : selectedSpecsheet?.f2_size,
                            isLeftHanded:
                              selectedSpecsheet?.hand === "left_hander",
                            is2Hander,
                          }}
                          isPhone={isPhone}
                          spanMeasurement={spanMeasurement}
                          ballId={localCurrentBall?.id}
                          access_token={access_token}
                        />
                      </div>
                    ) : (
                      // === Static Image View ===
                      <Image
                        style={imageBall}
                        src={image === null ? ballImageDefault : image}
                        fluid={"true"}
                        alt={""}
                        wrapperProps={{
                          style: { height: "unset", width: "100%" },
                        }}
                        placeholderSrc={ballImageDefault}
                      />
                    )}

                    <ShadowImage />
                  </ImageDiv>
                )}
                {savingPhoto && (
                  <ImageLoader>
                    <Loader />
                  </ImageLoader>
                )}

                <ConnectedImageButtonContainer
                  show3D={show3D}
                  button3dClick={handle3dClick}
                  disabled3D={
                    !is3DLayoutValid &&
                    (localCurrentBall?.layout_type || currentLayout) !== "none"
                  }
                  circle={true}
                  includeTag={false}
                  currentPhoto={image}
                  onFromCamera={(imageBase64) => {
                    ballSavePhoto({ imageBase64 });
                    setPhotoShowModal(false);
                  }}
                  onFromGallery={(imageBase64) => {
                    ballSavePhoto({ imageBase64 });
                    setPhotoShowModal(false);
                  }}
                  handleDeleteImageClick={() => {
                    setShowConfirmDelete(true);
                  }}
                />
                {pluginSubscriptions.indexOf("BOWLING_DATABASE") >= 0 && (
                  <div style={{ textAlign: "center" }}>
                    <Form.Label>{t("form.label.hole_depths")}</Form.Label>
                    <div
                      style={{
                        display: "flex",
                        gap: "30px",
                        marginTop: "10px",
                      }}
                    >
                      <HoleDepthSection
                        onClick={() => {
                          setHoleNumberValue(0);
                          setShowHoleDepthModal(true);
                        }}
                      >
                        {display_measurement === "fraction"
                          ? toFractionRound(firstHoleDepth, 4)
                          : firstHoleDepth}
                      </HoleDepthSection>
                      <HoleDepthSection
                        onClick={() => {
                          setHoleNumberValue(1);
                          setShowHoleDepthModal(true);
                        }}
                      >
                        {display_measurement === "fraction"
                          ? toFractionRound(secondHoleDepth, 4)
                          : secondHoleDepth}
                      </HoleDepthSection>
                    </div>
                    <div
                      style={{
                        display: !is2Hander ? "flex" : "none",
                        marginLeft: "50px",
                        marginTop: "10px",
                      }}
                    >
                      <HoleDepthSection
                        onClick={() => {
                          setHoleNumberValue(2);
                          setShowHoleDepthModal(true);
                        }}
                      >
                        {display_measurement === "fraction"
                          ? toFractionRound(thumbHoleDepth, 4)
                          : thumbHoleDepth}
                      </HoleDepthSection>
                    </div>
                  </div>
                )}

                {pluginSubscriptions.indexOf("JOB_BOARD") >= 0 && (
                  <CreateJobContainer></CreateJobContainer>
                )}
              </ImageContainer>
            </BallContainerInfo>
            {pluginSubscriptions.indexOf("JOB_BOARD") >= 0 && (
              <JobBoardBallList
                jobs={currentJobs}
                loadingCustomer={loadingCustomer}
                ballID={ballID}
                bowlerID={bowlerID}
                plugin_settings={plugin_settings}
                jobServices={jobServices}
                deviceInfo={deviceInfo}
              />
            )}
            <PhotoSelect
              circle={true}
              show={showPhotoModal}
              onHide={() => {
                setPhotoShowModal(false);
              }}
              onFromCamera={(imageBase64) => {
                ballSavePhoto({ imageBase64 });
                setPhotoShowModal(false);
              }}
              onFromGallery={(imageBase64) => {
                ballSavePhoto({ imageBase64 });
                setPhotoShowModal(false);
              }}
              onFromCrop={(imageBase64) => {
                ballSavePhoto({ imageBase64 });
                setPhotoShowModal(false);
              }}
              currentPhoto={image}
              showDeleteButton={true}
              onDeleteButtonClick={() => {
                setShowConfirmDelete(true);
                setPhotoShowModal(false);
              }}
            />
            <ConfirmDelete
              show={showConfirmDelete}
              onHide={() => {
                setShowConfirmDelete(false);
              }}
              onConfirmClick={() => {
                ballSavePhoto({ imageBase64: "" });
                setShowConfirmDelete(false);
              }}
            />
            <ConfirmDeleteArsenal
              show={showConfirmDeleteArsenal}
              onHide={() => {
                setShowConfirmDeleteArsenal(false);
              }}
              onConfirmClick={() => {
                handleDeleteBall();
                setShowConfirmDeleteArsenal(false);
              }}
            />
            <NoSerialNumberAlert
              show={showNoSerialNumberAlert}
              onHide={() => {
                setShowNoSerialNumberAlert(false);
              }}
            />
            {readingBarcode && (
              <BarcodeReader>
                <Html5QrcodePlugin
                  fps={10}
                  qrbox={(viewfinderWidth, viewfinderHeight) => {
                    let minEdgePercentage = 0.9; // 90%
                    let minEdgeSize = Math.min(
                      viewfinderWidth,
                      viewfinderHeight,
                    );
                    let qrboxSize = Math.floor(minEdgeSize * minEdgePercentage);
                    let qrboxSize2 = Math.floor(
                      minEdgeSize * (minEdgePercentage - 0.35),
                    );

                    return {
                      width: qrboxSize,
                      height: qrboxSize2,
                    };
                  }}
                  disableFlip={true}
                  onStop={() => {
                    readBarcodeSuccess();
                  }}
                  qrCodeSuccessCallback={(code) => {
                    readBarcodeSuccess({ barcode: code });
                    getBallDatabaseInfoScan({ q: code });
                  }}
                />
              </BarcodeReader>
            )}
            {readingSerialNumber && (
              <BarcodeReader>
                <Html5QrcodePlugin
                  fps={10}
                  qrbox={(viewfinderWidth, viewfinderHeight) => {
                    let minEdgePercentage = 0.9; // 90%
                    let minEdgeSize = Math.min(
                      viewfinderWidth,
                      viewfinderHeight,
                    );
                    let qrboxSize = Math.floor(minEdgeSize * minEdgePercentage);
                    let qrboxSize2 = Math.floor(
                      minEdgeSize * (minEdgePercentage - 0.35),
                    );

                    return {
                      width: qrboxSize,
                      height: qrboxSize2,
                    };
                  }}
                  disableFlip={true}
                  onStop={() => {
                    setReadingSerialNumber(false);
                  }}
                  qrCodeSuccessCallback={(code) => {
                    handleBarcodeValues({
                      serial_number: code,
                    });
                    setReadingSerialNumber(false);
                  }}
                />
              </BarcodeReader>
            )}
            {pluginSubscriptions.indexOf("SPECTRE_POS") >= 0 && (
              <ModalUpdateError
                show={showAlert}
                onHide={() => {
                  resetErrorMessage({});
                  setShowAlert(false);
                }}
                confirmDescription={showAlertMessage}
                confirmHeader={showAlertHeader}
                productsLink={api_url + "/wp-admin/edit.php?post_type=product"}
              />
            )}
            {pluginSubscriptions.indexOf("BOWLING_DATABASE") >= 0 && (
              <Modal
                centered
                show={showSearchBallModal}
                fullscreen={"md-down"}
                size={"lg"}
                onHide={() => {
                  setShowSearchBallModal(false);
                  setOpenBallDatabaseSearch({
                    open: false,
                  });
                }}
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    <Image
                      src={BowlingDatabaseLogo}
                      style={{
                        borderRadius: 10,
                        width: 300,
                      }}
                    />
                  </Modal.Title>
                </Modal.Header>
                <BallSearch
                  bowlingdata={ballDatabaseBalls}
                  totalRecords={ballDatabaseBallsTotalRecords}
                  loading={gettingBallDatabaseInfo}
                  isPhone={isPhone}
                  onSelect={(ball) => {
                    // Check if the current ball matches the selected ball
                    const ballIsNew =
                      currentBall?.ball_name === "" ||
                      currentBall?.manufacturer === "" ||
                      currentBall?.weight === "";

                    const currentBallValues = JSON.parse(
                      JSON.stringify(currentBall),
                    );

                    //Add check for current ball being empty/new here
                    setBallDatabaseInfo({
                      ball,
                    });
                    setShowSearchBallModal(false);
                    setOpenBallDatabaseSearch({
                      open: false,
                    });
                    //This is where we check for woocommerce
                    if (pluginSubscriptions.indexOf("SPECTRE_POS") >= 0) {
                      const sku =
                        ball.manufacturer_item_number ||
                        ball.barcode ||
                        ball.upc ||
                        "";
                      handleWoocommerceSetup(
                        ball,
                        ballIsNew,
                        currentBallValues,
                        ballIsNew ? sku : undefined,
                      );
                    }
                  }}
                  handleBallSearch={handleBallSearch}
                  ballSearch={ballSearch}
                  setBallSearch={setBallSearch}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  size={size}
                  setSize={setSize}
                  actPage={actPage}
                  setActPage={setActPage}
                  rangeFinal={rangeFinal}
                  setRangeFinal={setRangeFinal}
                  rangeInitial={rangeInitial}
                  setRangeInitial={setRangeInitial}
                  manufacturer={filtersManufacturer}
                  setManufacturer={setFiltersManufacturer}
                  coreType={coreType}
                  setCoreType={setCoreType}
                  coreName={coreName}
                  setCoreName={setCoreName}
                  coverstock={coverstock}
                  setCoverstock={setCoverstock}
                  rgMinValue={rgMinValue}
                  setRgMinValue={setRgMinValue}
                  rgMaxValue={rgMaxValue}
                  setRgMaxValue={setRgMaxValue}
                  diffMinValue={diffMinValue}
                  setDiffMinValue={setDiffMinValue}
                  diffMaxValue={diffMaxValue}
                  setDiffMaxValue={setDiffMaxValue}
                  intMinValue={intMinValue}
                  setIntMinValue={setIntMinValue}
                  intMaxValue={intMaxValue}
                  setIntMaxValue={setIntMaxValue}
                  filters={filters}
                  order={order}
                  setOrder={setOrder}
                  searchBaseFilters={searchBaseFilters}
                  selectedBalls={ballDatabaseSelectedBalls}
                  getBalldatabaseInfo={getBallDatabaseInfo}
                  api_key={api_key}
                  api_secret={api_secret}
                  api_url={api_url}
                />
              </Modal>
            )}
            <Modal
              show={showConversionModal}
              onHide={() => {
                setShowConversionModal(false);
              }}
              centered
              size="sm"
              className="select-modal"
            >
              <Modal.Header closeButton style={{ borderBottom: "none" }}>
                <div style={{ marginTop: 10, lineHeight: 1.2 }}>
                  <span style={labelStyle}>{t("Layout Converter")}</span>
                </div>
              </Modal.Header>
              <Modal.Body
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <span style={labelStyle}>
                    {t("Convert Values From ")}{" "}
                    {t(layout_type) || t(currentLayout)} {t(" to ")}{" "}
                    {t(convertTo)}?
                  </span>

                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <ButtonLayoutType
                      style={{
                        position: "relative",
                        border: "none",
                        borderRadius: 5,
                        backgroundColor: "#00297A",
                        color: "#FFFFFF",
                        margin: 5,
                        width: "55px",
                        height: "40px",
                      }}
                      onClick={() => {
                        handleConversion(
                          layout_type || currentLayout,
                          convertTo,
                        );
                        setShowConversionModal(false);
                      }}
                    >
                      {t("yes")}
                    </ButtonLayoutType>
                    <ButtonLayoutType
                      style={{
                        position: "relative",
                        border: "none",
                        borderRadius: 5,
                        backgroundColor: "#00297A",
                        color: "#FFFFFF",
                        margin: 5,
                        width: "55px",
                        height: "40px",
                      }}
                      onClick={() => {
                        setShowConversionModal(false);
                      }}
                    >
                      {t("message.confirm.cancel")}
                    </ButtonLayoutType>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
            <ModalNoPAP
              show={showNoPAPModal}
              onHide={() => {
                setShowNoPAPModal(false);
              }}
            />
            <ModalHoleDepth
              show={showHoleDepthModal}
              numberValue={holeNumberValue}
              display_measurement={display_measurement}
              currentValue={
                holeNumberValue === 0
                  ? firstHoleDepth
                  : holeNumberValue === 1
                    ? secondHoleDepth
                    : thumbHoleDepth
              }
              onHide={() => {
                setShowHoleDepthModal(false);
              }}
              onChange={(value) => {
                if (holeNumberValue === 0) {
                  setFirstHoleDepth(value);
                  updateBallDepth("f1_depth", value);
                } else if (holeNumberValue === 1) {
                  setSecondHoleDepth(value);
                  updateBallDepth("f2_depth", value);
                } else if (holeNumberValue === 2) {
                  setThumbHoleDepth(value);
                  updateBallDepth("thumb_depth", value);
                }
              }}
            />
            <Modal3dError
              show={show3dErrorModal}
              errorType={show3dErrorType}
              onHide={() => {
                setShow3dErrorModal(false);
              }}
            />
          </>
        )}
        <ConfirmDialog
          show={showAddToOrderConfirm}
          onHide={() => setShowAddToOrderConfirm(false)}
          severity="warning"
          title={t("spectrepos.add_to_order_title")}
          description={t("spectrepos.add_to_order_body")}
          confirmText={t("spectrepos.add_to_order_confirm")}
          onConfirm={() => handleAddToOrder(false)}
        />
        <InsertColorPicker
          show={showInsertPicker}
          onHide={() => setShowInsertPicker(false)}
          specSheet={selectedSpecsheet}
          is2Hander={is2Hander}
          initialColors={
            parseExtraValuesDeep(currentBall?.extra_values)?.insert_colors || {}
          }
          onConfirm={({ colors, slots }) => {
            setPendingPickerResult({ colors, slots });
            setShowInsertPicker(false);
            persistInsertColors(colors);
            lastSeenBallCheckSeqRef.current = ball_in_order_check_seq;
            woocommerceCheckBallInOpenOrder({
              first_name: selectedCustomer?.firstname,
              last_name: selectedCustomer?.lastname,
              email: selectedCustomer?.email,
              ball_name: currentBall?.ball_name,
              manufacturer: currentBall?.manufacturer,
              sku:
                parseExtraValuesDeep(currentBall?.extra_values).barcode || "",
            });
          }}
        />
        <Modal
          show={showAddOrReplaceConfirm}
          onHide={() => setShowAddOrReplaceConfirm(false)}
          centered
        >
          <Modal.Header closeButton>
            <span
              style={{
                color: "#00187E",
                fontWeight: 700,
                fontSize: 16,
                fontFamily:
                  "'Poppins', system-ui, -apple-system, sans-serif",
              }}
            >
              {t("spectrepos.add_or_replace_title")}
            </span>
          </Modal.Header>
          <Modal.Body
            style={{
              textAlign: "center",
              fontFamily:
                "'Poppins', system-ui, -apple-system, sans-serif",
              fontSize: 14,
              color: "#202124",
            }}
          >
            {t("spectrepos.add_or_replace_body")}
          </Modal.Body>
          <Modal.Footer>
            <ButtonIcon
              variant="light"
              onClick={() => setShowAddOrReplaceConfirm(false)}
            >
              {t("message.confirm.cancel")}
            </ButtonIcon>
            <ButtonIcon
              variant="outline-primary"
              onClick={() => handleAddToOrder(false)}
            >
              {t("spectrepos.add_or_replace_add")}
            </ButtonIcon>
            <ButtonIcon
              variant="outline-danger"
              onClick={() => handleAddToOrder(true)}
            >
              {t("spectrepos.add_or_replace_replace")}
            </ButtonIcon>
          </Modal.Footer>
        </Modal>
        <ModalPdfPreview
          show={showPdfPreview}
          onHide={() => setShowPdfPreview(false)}
          pdfPath={(() => {
            // Specsheet resolution:
            //   1. The one selected in "Spec Sheet Used" dropdown of this ball
            //   2. Fallback to the customer's current selected specsheet
            //   3. Fallback to the most recent specsheet in the list
            const sId =
              spec_sheet?.id ||
              spec_sheet_id ||
              currentSpecSheet?.id ||
              specsheets?.[0]?.id;
            return sId ? `render/specsheet/${bowlerID}/${sId}` : null;
          })()}
          // ballId scopes the arsenal table to this single ball — matches the
          // legacy BallScreen print context (one specific ball, not the whole
          // customer arsenal).
          pdfParams={ballID ? { ballId: ballID } : undefined}
          fileName={
            localCurrentBall?.ball_name
              ? `specsheet-${localCurrentBall.ball_name}`
              : "specsheet"
          }
        />
      </div>
    </>
  );
};

export const BallScreen = connect(
  (state) => ({
    loadingCustomer: state.bowlers.loadingCustomer,
    deviceInfo: state.userSession.deviceInfo,
    selectedCustomer: state.bowlers.selectedCustomer,
    currentBall: state.balls.currentBall,
    arsenal_layout_style:
      state.settings.appSettings.layoutPreferences.arsenal_layout_style,
    arsenal_layout_convert:
      state.settings.appSettings.layoutPreferences.arsenal_layout_convert,
    loadingBalls: state.balls.loading,
    balls_drilled: state.bowlers.selectedCustomer?.balls_drilled || [],
    specsheets: state.bowlers.selectedCustomer?.specsheets || [],
    currentSpecSheet: state.specsheet.currentSpecSheet,
    currentLayout:
      state.settings.appSettings.layoutPreferences.arsenal_layout_style,
    state: state,
    spanMeasurement: state.settings.appSettings.systemDefault.span_measurement,
    display_measurement:
      state.settings.appSettings.systemDefault.display_measurement,
    userId: state.userSession.userData.id,
    savingPhoto: state.balls.savingPhoto,
    isReadOnly: state.userSession.isReadOnly,
    is2Hander:
      state.bowlers.selectedCustomer?.style === "two_handed" ||
      state.bowlers.selectedCustomer?.style === "thumbless",
    havePap:
      (state.bowlers.selectedCustomer?.pap_h &&
        state.bowlers.selectedCustomer?.pap_h !== "") ||
      (state.bowlers.selectedCustomer?.pap_v &&
        state.bowlers.selectedCustomer?.pap_v !== "") ||
      (state.bowlers.selectedCustomer?.pap_u_d &&
        state.bowlers.selectedCustomer?.pap_u_d !== "") ||
      (state.bowlers.selectedCustomer?.pap_ud &&
        state.bowlers.selectedCustomer?.pap_ud !== ""),
    pluginSubscriptions: state.plugin.pluginSubscriptions,
    currentJobs: state.balls.currentJobs,
    plugin_settings: state.plugin.plugin_settings,
    jobServices: state.plugin.jobServices,
    isPhone: state.userSession.deviceInfo.isMobileDevice,
    require_serial_number: state.plugin.plugin_settings.require_serial_number,
    readingBarcode: state.balls.readingBarcode,
    gettingBallDatabaseInfo: state.balls.gettingBallDatabaseInfo,
    ballDatabaseBalls: state.balls.ballDatabaseBalls,
    ballDatabaseBallsTotalRecords: state.balls.ballDatabaseBallsTotalRecords,
    settingBallDatabaseInfo: state.balls.settingBallDatabaseInfo,
    errorMessage: state.plugin.errorMessage,
    showSuggestedLayouts:
      state.settings.appSettings.autoSuggestions
        .spec_sheet_show_suggested_layouts,
    dualAngleMeasurment:
      state.settings.appSettings.layoutPreferences.dual_angle_measurement,
    api_url: state.plugin.plugin_settings.api_url,
    api_key: state.plugin.plugin_settings.api_key,
    api_secret: state.plugin.plugin_settings.api_secret,
    last_woocommerce_order_id: state.plugin.last_woocommerce_order_id,
    last_woocommerce_order_event_seq:
      state.plugin.last_woocommerce_order_event_seq,
    ball_in_order_check_seq: state.plugin.ball_in_order_check_seq,
    ball_in_order_check_result: state.plugin.ball_in_order_check_result,
    last_missing_inserts: state.plugin.last_missing_inserts,
    last_missing_inserts_seq: state.plugin.last_missing_inserts_seq,
    posSendFromSpectre:
      state.plugin.plugin_settings.pos_send_from_spectre !== false,
    last_pos_open_url: state.plugin.last_pos_open_url,
    last_pos_order_error: state.plugin.last_pos_order_error,
    last_pos_order_error_seq: state.plugin.last_pos_order_error_seq,
    filters: state.balls.ballDatabaseFilters,
    ballDatabaseSelectedBalls: state.balls.ballDatabaseSelectedBalls,
    openBallDatabaseSearch: state.balls.openBallDatabaseSearch,
    papDirection: state.bowlers.selectedCustomer?.pap_ud,
    papH: state.bowlers.selectedCustomer?.pap_h,
    papV: state.bowlers.selectedCustomer?.pap_v,
    convertSettings: state.plugin.plugin_settings.convert_layouts,
    access_token: state.userSession.accessData.access_token,
    showConfirmDeleteArsenal: state.balls.showConfirmDeleteArsenal,
  }),
  {
    getCustomer,
    setLoadBalls,
    ballHandleForm,
    ballAddNew,
    ballSelect,
    ballSavePhoto,
    ballRemovePhoto,
    ballRemove,
    createJob,
    openPhoto,
    readBarcode,
    readBarcodeSuccess,
    getBallDatabaseInfo,
    getBallDatabaseInfoScan,
    setBallDatabaseInfo,
    getBallDatabaseSearch,
    setOpenBallDatabaseSearch,
    woocommerceCheckUserExists,
    woocommerceCheckBallInOpenOrder,
    resetErrorMessage,
    setShowConfirmDeleteArsenal,
  },
)(BallRedux);
